var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Type, Transform } from 'class-transformer';
import { IsInt, IsNumber, IsIn, IsArray, IsString, IsDateString, IsUUID, IsNotEmpty, ValidateNested, IsOptional, IsBoolean, } from 'class-validator';
import { injectable } from 'inversify';
import { HttpService } from '@vk-hr-tek/core/http';
import { FiltersResponse, } from '@vk-hr-tek/core/filter';
import { ValidationService } from '@vk-hr-tek/core/validation';
import { UnmarshallerService } from '@vk-hr-tek/core/unmarshaller';
import { QueryService } from '@vk-hr-tek/core/query';
export class GetEventEmployeeAbsenceListParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventEmployeeAbsenceListParams.prototype, "event_id", void 0);
export class GetEventEmployeesParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventEmployeesParams.prototype, "event_id", void 0);
export class GetEventStaffPositionEmployeesParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventStaffPositionEmployeesParams.prototype, "event_id", void 0);
export class GetEventCompetencyOptionsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventCompetencyOptionsParams.prototype, "event_id", void 0);
export class GetEventAttributeOptionsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventAttributeOptionsParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventAttributeOptionsParams.prototype, "attribute_id", void 0);
export class GetVacationScheduleEventParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetVacationScheduleEventParams.prototype, "event_id", void 0);
export class GetAvailableScheduleEventFiltersParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetAvailableScheduleEventFiltersParams.prototype, "schedule_id", void 0);
export class GetScheduleFavoritesEventsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetScheduleFavoritesEventsParams.prototype, "schedule_id", void 0);
export class GetScheduleEventsXlsxParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetScheduleEventsXlsxParams.prototype, "schedule_id", void 0);
export class GetScheduleEventsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetScheduleEventsParams.prototype, "schedule_id", void 0);
export class EventAttributeCacheFileParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventAttributeCacheFileParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventAttributeCacheFileParams.prototype, "attribute_id", void 0);
export class GetEventAttributeFileParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventAttributeFileParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventAttributeFileParams.prototype, "attribute_id", void 0);
export class MarkDocumentAsReadParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MarkDocumentAsReadParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MarkDocumentAsReadParams.prototype, "document_id", void 0);
export class GetEventDocumentFileHashParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventDocumentFileHashParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventDocumentFileHashParams.prototype, "document_id", void 0);
export class EventFlowPdfParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventFlowPdfParams.prototype, "event_id", void 0);
export class RequestEventDocumentDocxFileParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RequestEventDocumentDocxFileParams.prototype, "event_id", void 0);
export class GetEventDocumentZipParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventDocumentZipParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventDocumentZipParams.prototype, "document_id", void 0);
export class GetEventDocumentFileWithStampParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventDocumentFileWithStampParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventDocumentFileWithStampParams.prototype, "document_id", void 0);
export class GetEventDocumentFileParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventDocumentFileParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventDocumentFileParams.prototype, "document_id", void 0);
export class DoCompetencyProfileParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoCompetencyProfileParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoCompetencyProfileParams.prototype, "node_id", void 0);
export class DoCompetencyEvalParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoCompetencyEvalParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoCompetencyEvalParams.prototype, "node_id", void 0);
export class DoPepSignParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoPepSignParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoPepSignParams.prototype, "node_id", void 0);
export class DoUkepSignParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoUkepSignParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoUkepSignParams.prototype, "node_id", void 0);
export class RequestUnepSignBatchCodeParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RequestUnepSignBatchCodeParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RequestUnepSignBatchCodeParams.prototype, "node_id", void 0);
export class DoUnepSignBatchParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoUnepSignBatchParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoUnepSignBatchParams.prototype, "node_id", void 0);
export class RequestUnepSignCodeParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RequestUnepSignCodeParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RequestUnepSignCodeParams.prototype, "node_id", void 0);
export class DoUnepSignParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoUnepSignParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoUnepSignParams.prototype, "node_id", void 0);
export class DocumentGenerateFromTemplateParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DocumentGenerateFromTemplateParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DocumentGenerateFromTemplateParams.prototype, "node_id", void 0);
export class DocumentGeneratePreviewFromTemplateParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DocumentGeneratePreviewFromTemplateParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DocumentGeneratePreviewFromTemplateParams.prototype, "node_id", void 0);
export class DoDeclineSignParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoDeclineSignParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoDeclineSignParams.prototype, "node_id", void 0);
export class DoDeclineParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoDeclineParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoDeclineParams.prototype, "node_id", void 0);
export class DoRetryParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoRetryParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoRetryParams.prototype, "node_id", void 0);
__decorate([
    IsIn([
        'upload',
        'upload_batch',
        'accept',
        'ukep_sign',
        'ukep_sign_batch',
        'unep_sign',
        'unep_sign_batch',
        'pep_sign',
        'pep_sign_batch',
        'generate_document_from_template',
        'decline',
        'decline_sign',
        'return',
        'competency_eval',
        'competency_profile',
        'competency_fill',
        'system',
        'system_validate_sign',
        'system_set_vacation_days',
        'system_sync_scheduled_vacations',
        'system_booking_hook',
        'system_booking_approve',
        'system_booking_limits_exceeded_approve',
        'system_booking_trip_create',
        'system_linkedtrip_attrinfo',
        'system_linkedtrip_approveinfo',
        'system_booking_trip_info',
        'system_booking_trip_change',
        'system_booking_trip_ordering',
        'system_booking_trip_limit',
        'system_booking_trip_limit_approved',
        'system_business_trip_file_delivery',
        'system_deadline',
        'system_condition_positive',
        'system_condition_negative',
        'system_condition_0',
        'system_condition_1',
        'system_condition_2',
        'system_condition_3',
        'system_condition_4',
        'system_condition_5',
        'system_condition_6',
        'system_condition_7',
        'system_condition_8',
        'system_condition_9',
        'system_create_request_sw',
        'system_trip_info_sw',
        'system_item_voucher_sw',
        'system_cancel_request_sw',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoRetryParams.prototype, "action_type", void 0);
export class EventAttributesResetParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventAttributesResetParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventAttributesResetParams.prototype, "node_id", void 0);
__decorate([
    IsIn([
        'upload',
        'upload_batch',
        'accept',
        'ukep_sign',
        'ukep_sign_batch',
        'unep_sign',
        'unep_sign_batch',
        'pep_sign',
        'pep_sign_batch',
        'generate_document_from_template',
        'decline',
        'decline_sign',
        'return',
        'competency_eval',
        'competency_profile',
        'competency_fill',
        'system',
        'system_validate_sign',
        'system_set_vacation_days',
        'system_sync_scheduled_vacations',
        'system_booking_hook',
        'system_booking_approve',
        'system_booking_limits_exceeded_approve',
        'system_booking_trip_create',
        'system_linkedtrip_attrinfo',
        'system_linkedtrip_approveinfo',
        'system_booking_trip_info',
        'system_booking_trip_change',
        'system_booking_trip_ordering',
        'system_booking_trip_limit',
        'system_booking_trip_limit_approved',
        'system_business_trip_file_delivery',
        'system_deadline',
        'system_condition_positive',
        'system_condition_negative',
        'system_condition_0',
        'system_condition_1',
        'system_condition_2',
        'system_condition_3',
        'system_condition_4',
        'system_condition_5',
        'system_condition_6',
        'system_condition_7',
        'system_condition_8',
        'system_condition_9',
        'system_create_request_sw',
        'system_trip_info_sw',
        'system_item_voucher_sw',
        'system_cancel_request_sw',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventAttributesResetParams.prototype, "action_type", void 0);
export class EventNodeActionExternalProcessingParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventNodeActionExternalProcessingParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventNodeActionExternalProcessingParams.prototype, "node_id", void 0);
__decorate([
    IsIn([
        'upload',
        'upload_batch',
        'accept',
        'ukep_sign',
        'ukep_sign_batch',
        'unep_sign',
        'unep_sign_batch',
        'pep_sign',
        'pep_sign_batch',
        'generate_document_from_template',
        'decline',
        'decline_sign',
        'return',
        'competency_eval',
        'competency_profile',
        'competency_fill',
        'system',
        'system_validate_sign',
        'system_set_vacation_days',
        'system_sync_scheduled_vacations',
        'system_booking_hook',
        'system_booking_approve',
        'system_booking_limits_exceeded_approve',
        'system_booking_trip_create',
        'system_linkedtrip_attrinfo',
        'system_linkedtrip_approveinfo',
        'system_booking_trip_info',
        'system_booking_trip_change',
        'system_booking_trip_ordering',
        'system_booking_trip_limit',
        'system_booking_trip_limit_approved',
        'system_business_trip_file_delivery',
        'system_deadline',
        'system_condition_positive',
        'system_condition_negative',
        'system_condition_0',
        'system_condition_1',
        'system_condition_2',
        'system_condition_3',
        'system_condition_4',
        'system_condition_5',
        'system_condition_6',
        'system_condition_7',
        'system_condition_8',
        'system_condition_9',
        'system_create_request_sw',
        'system_trip_info_sw',
        'system_item_voucher_sw',
        'system_cancel_request_sw',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventNodeActionExternalProcessingParams.prototype, "action_type", void 0);
export class DoAcceptParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoAcceptParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoAcceptParams.prototype, "node_id", void 0);
export class DoReturnParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoReturnParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoReturnParams.prototype, "node_id", void 0);
export class DoUploadBatchParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoUploadBatchParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoUploadBatchParams.prototype, "node_id", void 0);
export class DoUploadParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoUploadParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DoUploadParams.prototype, "node_id", void 0);
export class EventNodeValidatorsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventNodeValidatorsParams.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventNodeValidatorsParams.prototype, "node_id", void 0);
export class RestoreEventParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RestoreEventParams.prototype, "event_id", void 0);
export class CancelEventParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CancelEventParams.prototype, "event_id", void 0);
export class GetEventParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventParams.prototype, "event_id", void 0);
export class GetEventFlowParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventFlowParams.prototype, "event_id", void 0);
export class GetBookingSmartwayRedirectParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetBookingSmartwayRedirectParams.prototype, "event_id", void 0);
export class GetBookingRedirectParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetBookingRedirectParams.prototype, "event_id", void 0);
export class GetAttrOptionsParams {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetAttrOptionsParams.prototype, "attr_code", void 0);
export class EmployeeCompetencyEventsParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeCompetencyEventsParams.prototype, "employee_id", void 0);
export class EmployeeCompetencyParams {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeCompetencyParams.prototype, "employee_id", void 0);
export class GetCreateEventOptionsEmployeeEventTypesParams {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCreateEventOptionsEmployeeEventTypesParams.prototype, "employee_id", void 0);
export class GetEventEmployeesQuery {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventEmployeesQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventEmployeesQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventEmployeesQuery.prototype, "offset", void 0);
export class GetEventStaffPositionEmployeesQuery {
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventStaffPositionEmployeesQuery.prototype, "staff_position_id", void 0);
export class GetEventCompetencyOptionsQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventCompetencyOptionsQuery.prototype, "staff_position_id", void 0);
export class GetEventAttributeOptionsQuery {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetEventAttributeOptionsQuery.prototype, "ids", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetEventAttributeOptionsQuery.prototype, "values", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventAttributeOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventAttributeOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventAttributeOptionsQuery.prototype, "offset", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventAttributeOptionsQuery.prototype, "hierarchic_start_item_id", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetEventAttributeOptionsQuery.prototype, "hierarchic_view", void 0);
export class GetScheduleConsecutiveNumberFilterOptionsQuery {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetScheduleConsecutiveNumberFilterOptionsQuery.prototype, "schedule_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetScheduleConsecutiveNumberFilterOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetScheduleConsecutiveNumberFilterOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetScheduleConsecutiveNumberFilterOptionsQuery.prototype, "offset", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetScheduleConsecutiveNumberFilterOptionsQuery.prototype, "tags", void 0);
export class GetScheduleEventEmployeeFilterOptionsQuery {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetScheduleEventEmployeeFilterOptionsQuery.prototype, "schedule_id", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetScheduleEventEmployeeFilterOptionsQuery.prototype, "ids", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetScheduleEventEmployeeFilterOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetScheduleEventEmployeeFilterOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetScheduleEventEmployeeFilterOptionsQuery.prototype, "offset", void 0);
export class GetScheduleFavoritesEventsQuery {
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetScheduleFavoritesEventsQuery.prototype, "event_id", void 0);
export class GetEventAttributeFileQuery {
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventAttributeFileQuery.prototype, "id", void 0);
export class CandidateEsiaExternalProcessingCallbackQuery {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CandidateEsiaExternalProcessingCallbackQuery.prototype, "state", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CandidateEsiaExternalProcessingCallbackQuery.prototype, "code", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CandidateEsiaExternalProcessingCallbackQuery.prototype, "error", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CandidateEsiaExternalProcessingCallbackQuery.prototype, "error_description", void 0);
export class GetBookingRedirectQuery {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetBookingRedirectQuery.prototype, "token", void 0);
export class GetCreateSimpleEventTypeOptionsQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCreateSimpleEventTypeOptionsQuery.prototype, "company_id", void 0);
export class GetEventStatusFilterOptionsQuery {
}
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetEventStatusFilterOptionsQuery.prototype, "ids", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventStatusFilterOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventStatusFilterOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventStatusFilterOptionsQuery.prototype, "offset", void 0);
export class GetEventSideFilterOptionsQuery {
}
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetEventSideFilterOptionsQuery.prototype, "ids", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventSideFilterOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventSideFilterOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventSideFilterOptionsQuery.prototype, "offset", void 0);
export class GetEventTypeGroupFilterOptionsQuery {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetEventTypeGroupFilterOptionsQuery.prototype, "ids", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventTypeGroupFilterOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventTypeGroupFilterOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventTypeGroupFilterOptionsQuery.prototype, "offset", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventTypeGroupFilterOptionsQuery.prototype, "company_id", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetEventTypeGroupFilterOptionsQuery.prototype, "tags", void 0);
export class GetDocumentTypeFilterOptionsQuery {
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetDocumentTypeFilterOptionsQuery.prototype, "company_id", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetDocumentTypeFilterOptionsQuery.prototype, "ids", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetDocumentTypeFilterOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetDocumentTypeFilterOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetDocumentTypeFilterOptionsQuery.prototype, "offset", void 0);
export class GetParentEventFilterOptionsQuery {
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetParentEventFilterOptionsQuery.prototype, "id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetParentEventFilterOptionsQuery.prototype, "company_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetParentEventFilterOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetParentEventFilterOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetParentEventFilterOptionsQuery.prototype, "offset", void 0);
export class GetEventBatchFilterOptionsQuery {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetEventBatchFilterOptionsQuery.prototype, "ids", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventBatchFilterOptionsQuery.prototype, "company_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventBatchFilterOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventBatchFilterOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventBatchFilterOptionsQuery.prototype, "offset", void 0);
export class GetEmployeePositionFilterOptionsQuery {
}
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetEmployeePositionFilterOptionsQuery.prototype, "names", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetEmployeePositionFilterOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEmployeePositionFilterOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEmployeePositionFilterOptionsQuery.prototype, "offset", void 0);
export class GetBusinessTripDestinationFilterOptionsQuery {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetBusinessTripDestinationFilterOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetBusinessTripDestinationFilterOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetBusinessTripDestinationFilterOptionsQuery.prototype, "offset", void 0);
export class GetConsecutiveNumberFilterOptionsQuery {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetConsecutiveNumberFilterOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetConsecutiveNumberFilterOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetConsecutiveNumberFilterOptionsQuery.prototype, "offset", void 0);
export class GetEmployeeFilterOptionsQuery {
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetEmployeeFilterOptionsQuery.prototype, "company_id", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetEmployeeFilterOptionsQuery.prototype, "ids", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetEmployeeFilterOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEmployeeFilterOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEmployeeFilterOptionsQuery.prototype, "offset", void 0);
export class GetAttrOptionsQuery {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetAttrOptionsQuery.prototype, "ids", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetAttrOptionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetAttrOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetAttrOptionsQuery.prototype, "offset", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetAttrOptionsQuery.prototype, "company_id", void 0);
export class GetAvailableEventFiltersAbsenceQuery {
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetAvailableEventFiltersAbsenceQuery.prototype, "company_id", void 0);
export class GetAvailableEventFiltersQuery {
}
__decorate([
    IsIn(['goal_management']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetAvailableEventFiltersQuery.prototype, "page", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetAvailableEventFiltersQuery.prototype, "tags", void 0);
export class GetCreateEventOptionsEventTypesQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCreateEventOptionsEventTypesQuery.prototype, "company_id", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCreateEventOptionsEventTypesQuery.prototype, "batch_enabled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCreateEventOptionsEventTypesQuery.prototype, "no_employee", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetCreateEventOptionsEventTypesQuery.prototype, "parent_event_id", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetCreateEventOptionsEventTypesQuery.prototype, "tag", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetCreateEventOptionsEventTypesQuery.prototype, "event_type_group", void 0);
export class GetEventTypeCreateOptionsQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventTypeCreateOptionsQuery.prototype, "event_type_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventTypeCreateOptionsQuery.prototype, "employee_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventTypeCreateOptionsQuery.prototype, "parent_event_id", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetEventTypeCreateOptionsQuery.prototype, "is_batch", void 0);
export class GetCreateEventOptionsEmployeeEventTypesQuery {
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetCreateEventOptionsEmployeeEventTypesQuery.prototype, "parent_event_id", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetCreateEventOptionsEmployeeEventTypesQuery.prototype, "tag", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetCreateEventOptionsEmployeeEventTypesQuery.prototype, "event_type_group", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCreateEventOptionsEmployeeEventTypesQuery.prototype, "collection_id", void 0);
export class GetCreateEventOptionsEmployeesQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCreateEventOptionsEmployeesQuery.prototype, "company_id", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCreateEventOptionsEmployeesQuery.prototype, "for_another", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetCreateEventOptionsEmployeesQuery.prototype, "unit_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetCreateEventOptionsEmployeesQuery.prototype, "employee_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetCreateEventOptionsEmployeesQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetCreateEventOptionsEmployeesQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetCreateEventOptionsEmployeesQuery.prototype, "offset", void 0);
export class EventCreateOptionsEventTypeParticipantOptionsQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventCreateOptionsEventTypeParticipantOptionsQuery.prototype, "event_type_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventCreateOptionsEventTypeParticipantOptionsQuery.prototype, "role_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventCreateOptionsEventTypeParticipantOptionsQuery.prototype, "search", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], EventCreateOptionsEventTypeParticipantOptionsQuery.prototype, "limit", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], EventCreateOptionsEventTypeParticipantOptionsQuery.prototype, "offset", void 0);
export class GetCreateEventOptionsCompaniesQuery {
}
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCreateEventOptionsCompaniesQuery.prototype, "with_event_types", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetCreateEventOptionsCompaniesQuery.prototype, "event_type_group_id", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetCreateEventOptionsCompaniesQuery.prototype, "tag", void 0);
export class GetCreateEventOptionsCommonQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetCreateEventOptionsCommonQuery.prototype, "company_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetCreateEventOptionsCommonQuery.prototype, "parent_event_id", void 0);
export class GetEventsXlsxQuery {
}
__decorate([
    IsIn(['events', 'documents']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventsXlsxQuery.prototype, "type", void 0);
export class GetEventBatchEmployeeCountQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventBatchEmployeeCountQuery.prototype, "event_type_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventBatchEmployeeCountQuery.prototype, "parent_event_id", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetEventBatchEmployeeCountQuery.prototype, "unit_ids", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetEventBatchEmployeeCountQuery.prototype, "positions", void 0);
export class GetEventBatchPositionsQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventBatchPositionsQuery.prototype, "event_type_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventBatchPositionsQuery.prototype, "parent_event_id", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetEventBatchPositionsQuery.prototype, "names", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventBatchPositionsQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventBatchPositionsQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventBatchPositionsQuery.prototype, "offset", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetEventBatchPositionsQuery.prototype, "unit_ids", void 0);
export class GetEventBatchEmployeesQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventBatchEmployeesQuery.prototype, "event_type_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventBatchEmployeesQuery.prototype, "parent_event_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetEventBatchEmployeesQuery.prototype, "query", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventBatchEmployeesQuery.prototype, "limit", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetEventBatchEmployeesQuery.prototype, "offset", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetEventBatchEmployeesQuery.prototype, "unit_ids", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], GetEventBatchEmployeesQuery.prototype, "positions", void 0);
export class GetEventBatchListQuery {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventBatchListQuery.prototype, "company_id", void 0);
export class GetCancelReasonsQuery {
}
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetCancelReasonsQuery.prototype, "is_candidate", void 0);
export class AbsenceIntersectionDay {
}
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceIntersectionDay.prototype, "date", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], AbsenceIntersectionDay.prototype, "total", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], AbsenceIntersectionDay.prototype, "fraction", void 0);
export class AbsenceIntersectionMonth {
}
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], AbsenceIntersectionMonth.prototype, "month", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => AbsenceIntersectionDay),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], AbsenceIntersectionMonth.prototype, "days", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], AbsenceIntersectionMonth.prototype, "total", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], AbsenceIntersectionMonth.prototype, "fraction", void 0);
export class AbsenceGroup {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceGroup.prototype, "name", void 0);
__decorate([
    IsIn([
        'vacation',
        'maternity_leave',
        'student_leave',
        'business_trip',
        'sick_leave',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceGroup.prototype, "nick", void 0);
export class EmployeeAbsence {
}
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeAbsence.prototype, "from_date", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeAbsence.prototype, "to_date", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EmployeeAbsence.prototype, "days_count", void 0);
__decorate([
    ValidateNested(),
    Type(() => AbsenceGroup),
    IsNotEmpty(),
    __metadata("design:type", AbsenceGroup)
], EmployeeAbsence.prototype, "absence_group", void 0);
export class CompanyItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyItem.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyItem.prototype, "tsp_url", void 0);
__decorate([
    IsIn(['capi', 'cades']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyItem.prototype, "crypto_pro_plugin_open_type", void 0);
__decorate([
    IsIn(['api', 'browser_plugin']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyItem.prototype, "hash_source", void 0);
export class CompanyEmployee {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "first_name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "middle_name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "last_name", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompanyItem),
    IsNotEmpty(),
    __metadata("design:type", CompanyItem)
], CompanyEmployee.prototype, "company", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "email", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "personnel_number", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "position", void 0);
__decorate([
    IsIn([
        'kontur',
        'goskey',
        'cryptopro_simple',
        'cryptopro_local',
        'disabled',
        'ukep',
    ]),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "sign_type", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "unit_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "expanded_unit_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "unit_name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "unit_breadcrumbs", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "user_id", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EmployeeAbsence),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CompanyEmployee.prototype, "absences", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompanyEmployee.prototype, "org_structure_type", void 0);
export class AbsenceUnit {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceUnit.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceUnit.prototype, "name", void 0);
__decorate([
    IsIn(['operational', 'legal']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceUnit.prototype, "type", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], AbsenceUnit.prototype, "parent_id", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompanyEmployee),
    IsOptional(),
    __metadata("design:type", CompanyEmployee)
], AbsenceUnit.prototype, "manager", void 0);
export class WorkScheduleDate {
}
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkScheduleDate.prototype, "date", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], WorkScheduleDate.prototype, "is_workday", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], WorkScheduleDate.prototype, "is_holiday", void 0);
export class WorkScheduleCalendar {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkScheduleCalendar.prototype, "id", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => WorkScheduleDate),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], WorkScheduleCalendar.prototype, "dates", void 0);
export class AbsenceActiveNode {
}
__decorate([
    IsIn(['upload', 'generate_document_from_template', 'sign', 'accept'], {
        each: true,
    }),
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], AbsenceActiveNode.prototype, "actions", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], AbsenceActiveNode.prototype, "deadline", void 0);
export class AbsenceItemEventTypes {
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], AbsenceItemEventTypes.prototype, "vacation_from_calendar", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], AbsenceItemEventTypes.prototype, "change_vacation_from_calendar", void 0);
export class AbsenceItem {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceItem.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AbsenceItem.prototype, "type_group", void 0);
__decorate([
    IsIn([
        'new',
        'event_created',
        'approved',
        'in_progress',
        'completed',
        'canceled',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceItem.prototype, "status", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceItem.prototype, "from_date", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceItem.prototype, "to_date", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], AbsenceItem.prototype, "days_count", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], AbsenceItem.prototype, "event_id", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], AbsenceItem.prototype, "is_scheduled_vacation", void 0);
__decorate([
    ValidateNested(),
    Type(() => AbsenceItemEventTypes),
    IsOptional(),
    __metadata("design:type", AbsenceItemEventTypes)
], AbsenceItem.prototype, "event_types", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => AbsenceActiveNode),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], AbsenceItem.prototype, "active_nodes", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], AbsenceItem.prototype, "intersections_count", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], AbsenceItem.prototype, "is_monetary_compensation", void 0);
export class WorkCalendarDate {
}
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkCalendarDate.prototype, "date", void 0);
__decorate([
    IsIn(['workday', 'weekend', 'holiday']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkCalendarDate.prototype, "type", void 0);
export class AbsenceEmployee {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceEmployee.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceEmployee.prototype, "name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AbsenceEmployee.prototype, "email", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AbsenceEmployee.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceEmployee.prototype, "personnel_number", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AbsenceEmployee.prototype, "position", void 0);
__decorate([
    ValidateNested(),
    Type(() => AbsenceUnit),
    IsOptional(),
    __metadata("design:type", AbsenceUnit)
], AbsenceEmployee.prototype, "unit", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => WorkCalendarDate),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], AbsenceEmployee.prototype, "calendar_diff", void 0);
export class AbsenceListGroup {
}
__decorate([
    IsIn(['self', 'colleague', 'manager']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AbsenceListGroup.prototype, "type", void 0);
__decorate([
    ValidateNested(),
    Type(() => AbsenceEmployee),
    IsNotEmpty(),
    __metadata("design:type", AbsenceEmployee)
], AbsenceListGroup.prototype, "employee", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => AbsenceItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], AbsenceListGroup.prototype, "absences", void 0);
__decorate([
    ValidateNested(),
    Type(() => WorkScheduleCalendar),
    IsOptional(),
    __metadata("design:type", WorkScheduleCalendar)
], AbsenceListGroup.prototype, "work_schedule", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => AbsenceUnit),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], AbsenceListGroup.prototype, "units", void 0);
export class AbsenceListResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => AbsenceListGroup),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], AbsenceListResponse.prototype, "groups", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => AbsenceIntersectionMonth),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], AbsenceListResponse.prototype, "intersections", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], AbsenceListResponse.prototype, "total", void 0);
export class EmployeeItem {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EmployeeItem.prototype, "personnel_number", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeItem.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EmployeeItem.prototype, "position", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EmployeeItem.prototype, "unit_name", void 0);
export class GetEventEmployeesResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => EmployeeItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetEventEmployeesResponse.prototype, "employees", void 0);
export class GetEventStaffPositionEmployeesResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => EmployeeItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetEventStaffPositionEmployeesResponse.prototype, "employees", void 0);
export class CompetencyScaleValue {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompetencyScaleValue.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompetencyScaleValue.prototype, "name", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], CompetencyScaleValue.prototype, "value", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CompetencyScaleValue.prototype, "indicators", void 0);
export class CompetencyItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompetencyItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompetencyItem.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompetencyItem.prototype, "description", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CompetencyItem.prototype, "group_name", void 0);
export class EventCompetencyOption {
}
__decorate([
    ValidateNested(),
    Type(() => CompetencyItem),
    IsNotEmpty(),
    __metadata("design:type", CompetencyItem)
], EventCompetencyOption.prototype, "competency", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => CompetencyScaleValue),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventCompetencyOption.prototype, "scale_values", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompetencyScaleValue),
    IsOptional(),
    __metadata("design:type", CompetencyScaleValue)
], EventCompetencyOption.prototype, "current_value", void 0);
export class GetEventCompetencyOptionsResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventCompetencyOption),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetEventCompetencyOptionsResponse.prototype, "competencies", void 0);
export class EventCatalogAttributesItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventCatalogAttributesItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventCatalogAttributesItem.prototype, "value", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventCatalogAttributesItem.prototype, "subtext", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], EventCatalogAttributesItem.prototype, "parent_id", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventCatalogAttributesItem.prototype, "is_hierarchic_group", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventCatalogAttributesItem.prototype, "system", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventCatalogAttributesItem.prototype, "has_children", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventCatalogAttributesItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventCatalogAttributesItem.prototype, "children", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventCatalogAttributesItem.prototype, "fias_level", void 0);
export class EventCatalogAttributes {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventCatalogAttributes.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventCatalogAttributes.prototype, "name", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EventCatalogAttributes.prototype, "quantity", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventCatalogAttributesItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventCatalogAttributes.prototype, "items", void 0);
export class ImportedAbsenceItem {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ImportedAbsenceItem.prototype, "type_name", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ImportedAbsenceItem.prototype, "from_date", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ImportedAbsenceItem.prototype, "to_date", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], ImportedAbsenceItem.prototype, "intersections_count", void 0);
export class EventCompetencyValue {
}
__decorate([
    ValidateNested(),
    Type(() => CompetencyScaleValue),
    IsNotEmpty(),
    __metadata("design:type", CompetencyScaleValue)
], EventCompetencyValue.prototype, "value", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventCompetencyValue.prototype, "is_employee", void 0);
export class EventCompetency {
}
__decorate([
    ValidateNested(),
    Type(() => CompetencyItem),
    IsNotEmpty(),
    __metadata("design:type", CompetencyItem)
], EventCompetency.prototype, "competency", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => CompetencyScaleValue),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventCompetency.prototype, "scale_values", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventCompetencyValue),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventCompetency.prototype, "values", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompetencyScaleValue),
    IsOptional(),
    __metadata("design:type", CompetencyScaleValue)
], EventCompetency.prototype, "required_level", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompetencyScaleValue),
    IsOptional(),
    __metadata("design:type", CompetencyScaleValue)
], EventCompetency.prototype, "current_value", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompetencyScaleValue),
    IsOptional(),
    __metadata("design:type", CompetencyScaleValue)
], EventCompetency.prototype, "new_value", void 0);
export class EventCompetencyGroup {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventCompetencyGroup.prototype, "name", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventCompetency),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventCompetencyGroup.prototype, "competencies", void 0);
export class VacationAvailableDaysPeriod {
}
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], VacationAvailableDaysPeriod.prototype, "period_start", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], VacationAvailableDaysPeriod.prototype, "period_end", void 0);
__decorate([
    IsNumber(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], VacationAvailableDaysPeriod.prototype, "days", void 0);
export class VacationAvailableDays {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], VacationAvailableDays.prototype, "vacation_type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], VacationAvailableDays.prototype, "type_name", void 0);
__decorate([
    IsNumber(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], VacationAvailableDays.prototype, "available_days", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], VacationAvailableDays.prototype, "allow_compensatory", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => VacationAvailableDaysPeriod),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], VacationAvailableDays.prototype, "periods", void 0);
export class EventOptions {
}
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], EventOptions.prototype, "available_vacation_days", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventOptions.prototype, "create_child_label", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => VacationAvailableDays),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventOptions.prototype, "available_vacation_days_by_types", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EventOptions.prototype, "docx_file_available", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EventOptions.prototype, "docx_multiple_files", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EventOptions.prototype, "show_calendar", void 0);
export class UserShortInfo {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UserShortInfo.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UserShortInfo.prototype, "first_name", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UserShortInfo.prototype, "last_name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UserShortInfo.prototype, "middle_name", void 0);
export class EventComment {
}
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventComment.prototype, "created_at", void 0);
__decorate([
    ValidateNested(),
    Type(() => UserShortInfo),
    IsOptional(),
    __metadata("design:type", UserShortInfo)
], EventComment.prototype, "user", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventComment.prototype, "info", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventComment.prototype, "comment", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventComment.prototype, "role", void 0);
__decorate([
    IsIn(['system', 'return']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventComment.prototype, "type", void 0);
export class EventPermissions {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventPermissions.prototype, "to_paper", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventPermissions.prototype, "cancel", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventPermissions.prototype, "create_linked", void 0);
export class RoleItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RoleItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RoleItem.prototype, "name", void 0);
export class EventParticipant {
}
__decorate([
    ValidateNested(),
    Type(() => RoleItem),
    IsNotEmpty(),
    __metadata("design:type", RoleItem)
], EventParticipant.prototype, "role", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => UserShortInfo),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventParticipant.prototype, "user", void 0);
export class BusinessTripRouteItem {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], BusinessTripRouteItem.prototype, "destination", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], BusinessTripRouteItem.prototype, "start_date", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], BusinessTripRouteItem.prototype, "end_date", void 0);
export class BusinessTripRoute {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => BusinessTripRouteItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], BusinessTripRoute.prototype, "periods", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], BusinessTripRoute.prototype, "totalWeekends", void 0);
export class AttributeEmployee {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AttributeEmployee.prototype, "value", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AttributeEmployee.prototype, "label", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AttributeEmployee.prototype, "unit_name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AttributeEmployee.prototype, "position", void 0);
export class AttributeValueGoal {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AttributeValueGoal.prototype, "name", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], AttributeValueGoal.prototype, "share", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], AttributeValueGoal.prototype, "mandatory", void 0);
export class AttributeValueGoalsFinalReview {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => AttributeValueGoal),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], AttributeValueGoalsFinalReview.prototype, "goals", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], AttributeValueGoalsFinalReview.prototype, "percentage_manager", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AttributeValueGoalsFinalReview.prototype, "justification", void 0);
export class AttributeValueGoalReview {
}
__decorate([
    ValidateNested(),
    Type(() => AttributeValueGoal),
    IsNotEmpty(),
    __metadata("design:type", AttributeValueGoal)
], AttributeValueGoalReview.prototype, "goal", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], AttributeValueGoalReview.prototype, "percentage_employee", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], AttributeValueGoalReview.prototype, "percentage_manager", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AttributeValueGoalReview.prototype, "actions", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AttributeValueGoalReview.prototype, "supporting_docs", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AttributeValueGoalReview.prototype, "justification", void 0);
export class AttributeValueGoalChange {
}
__decorate([
    ValidateNested(),
    Type(() => AttributeValueGoal),
    IsOptional(),
    __metadata("design:type", AttributeValueGoal)
], AttributeValueGoalChange.prototype, "goal", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AttributeValueGoalChange.prototype, "new_name", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], AttributeValueGoalChange.prototype, "new_share", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AttributeValueGoalChange.prototype, "change_reason", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], AttributeValueGoalChange.prototype, "is_deleted", void 0);
export class AttributeEntity {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AttributeEntity.prototype, "id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AttributeEntity.prototype, "name", void 0);
export class AttributeFile {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AttributeFile.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AttributeFile.prototype, "url", void 0);
export class AttributeCatalog_data {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], AttributeCatalog_data.prototype, "catalog_item_ids", void 0);
export class Attribute {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Attribute.prototype, "id", void 0);
__decorate([
    IsIn([
        'text',
        'textarea',
        'date',
        'datetime',
        'file',
        'file_multiple',
        'choice',
        'year',
        'text_catalog',
        'url',
        'text_fixed_catalog',
        'staff_position',
        'goals',
        'goals_change',
        'goals_review',
        'goals_final_review',
        'employee',
        'fns_verification',
        'address_catalog',
        'hierarchic_catalog',
        'orgstructure_catalog',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Attribute.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Attribute.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Attribute.prototype, "description", void 0);
__decorate([
    ValidateNested(),
    Type(() => AttributeCatalog_data),
    IsOptional(),
    __metadata("design:type", AttributeCatalog_data)
], Attribute.prototype, "catalog_data", void 0);
__decorate([
    IsIn(['esia']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Attribute.prototype, "label_icon", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", Object)
], Attribute.prototype, "value", void 0);
export class KonturSystemDown {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], KonturSystemDown.prototype, "cert", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], KonturSystemDown.prototype, "sign", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], KonturSystemDown.prototype, "message", void 0);
export class DocumentSignature {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DocumentSignature.prototype, "signed_by", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DocumentSignature.prototype, "signed_by_name", void 0);
__decorate([
    IsIn(['not_signed', 'signed', 'on_signing', 'can_sign', 'declined_sign']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DocumentSignature.prototype, "status", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], DocumentSignature.prototype, "unep_type_substituted", void 0);
__decorate([
    ValidateNested(),
    Type(() => KonturSystemDown),
    IsOptional(),
    __metadata("design:type", KonturSystemDown)
], DocumentSignature.prototype, "kontur_system_down", void 0);
export class Document {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Document.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Document.prototype, "document_type_name", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Document.prototype, "url", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Document.prototype, "url_with_stamp", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Document.prototype, "url_zip", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => DocumentSignature),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], Document.prototype, "signatures", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], Document.prototype, "read_at", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], Document.prototype, "show_read_at", void 0);
export class CustomState {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CustomState.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CustomState.prototype, "description", void 0);
__decorate([
    IsIn(['gray', 'darkgray', 'green', 'orange', 'purple', 'blue', 'red']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CustomState.prototype, "color", void 0);
export class NodeActionConfirmation {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], NodeActionConfirmation.prototype, "title", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], NodeActionConfirmation.prototype, "body", void 0);
export class NodeActionResponsible {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], NodeActionResponsible.prototype, "role", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], NodeActionResponsible.prototype, "name", void 0);
export class ActionExtraExternal_processingApplied {
}
__decorate([
    IsIn(['esia']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ActionExtraExternal_processingApplied.prototype, "processor", void 0);
__decorate([
    IsIn(['success', 'failed']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ActionExtraExternal_processingApplied.prototype, "result", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ActionExtraExternal_processingApplied.prototype, "error", void 0);
export class ActionExtraExternal_processing {
}
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], ActionExtraExternal_processing.prototype, "processors", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => ActionExtraExternal_processingApplied),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], ActionExtraExternal_processing.prototype, "applied", void 0);
export class ActionDocumentType {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ActionDocumentType.prototype, "node_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ActionDocumentType.prototype, "name", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], ActionDocumentType.prototype, "required", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], ActionDocumentType.prototype, "info_required", void 0);
export class ActionExtra {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => ActionDocumentType),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], ActionExtra.prototype, "document_types", void 0);
__decorate([
    IsIn(['candidate_notify']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ActionExtra.prototype, "marker", void 0);
__decorate([
    IsIn(['vacation_types']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ActionExtra.prototype, "info_type", void 0);
__decorate([
    ValidateNested(),
    Type(() => ActionExtraExternal_processing),
    IsOptional(),
    __metadata("design:type", ActionExtraExternal_processing)
], ActionExtra.prototype, "external_processing", void 0);
export class FormMetaObjectAttribute {
}
__decorate([
    IsIn(['attribute']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormMetaObjectAttribute.prototype, "type", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormMetaObjectAttribute.prototype, "id", void 0);
export class FormMetaObjectRow {
}
__decorate([
    IsIn(['row']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormMetaObjectRow.prototype, "type", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FormMetaObjectRow.prototype, "is_bottom", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => FormMetaObjectAttribute),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], FormMetaObjectRow.prototype, "objects", void 0);
export class FormMetaObjectSubBlock {
}
__decorate([
    IsIn(['subblock']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormMetaObjectSubBlock.prototype, "type", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], FormMetaObjectSubBlock.prototype, "is_multiple", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], FormMetaObjectSubBlock.prototype, "locked", void 0);
__decorate([
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], FormMetaObjectSubBlock.prototype, "objects", void 0);
export class FormMetaObjectBlock {
}
__decorate([
    IsIn(['block']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormMetaObjectBlock.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormMetaObjectBlock.prototype, "title", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormMetaObjectBlock.prototype, "description", void 0);
__decorate([
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], FormMetaObjectBlock.prototype, "objects", void 0);
export class FormMetaObjectDocument {
}
__decorate([
    IsIn(['document']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormMetaObjectDocument.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormMetaObjectDocument.prototype, "title", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormMetaObjectDocument.prototype, "description", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], FormMetaObjectDocument.prototype, "classes", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], FormMetaObjectDocument.prototype, "is_multiple", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], FormMetaObjectDocument.prototype, "locked", void 0);
__decorate([
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], FormMetaObjectDocument.prototype, "objects", void 0);
export class FormMetaObjectStep {
}
__decorate([
    IsIn(['step']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormMetaObjectStep.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormMetaObjectStep.prototype, "title", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormMetaObjectStep.prototype, "description", void 0);
__decorate([
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], FormMetaObjectStep.prototype, "objects", void 0);
export class FormAttributeTooltip {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormAttributeTooltip.prototype, "title", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormAttributeTooltip.prototype, "description", void 0);
__decorate([
    IsIn(['inline', 'disclaimer']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormAttributeTooltip.prototype, "style", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], FormAttributeTooltip.prototype, "visible", void 0);
export class FormAttributeInfoVacationDays {
}
__decorate([
    IsIn(['vacation_days']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormAttributeInfoVacationDays.prototype, "type", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], FormAttributeInfoVacationDays.prototype, "vacation_days", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], FormAttributeInfoVacationDays.prototype, "import_vacation_days", void 0);
export class FormAttributeCondition {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormAttributeCondition.prototype, "attribute_id", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], FormAttributeCondition.prototype, "equal", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], FormAttributeCondition.prototype, "unequal", void 0);
export class FormAttributeShowWhen {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => FormAttributeCondition),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], FormAttributeShowWhen.prototype, "conditions", void 0);
export class FormAttributeChoice {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormAttributeChoice.prototype, "label", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormAttributeChoice.prototype, "value", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FormAttributeChoice.prototype, "default", void 0);
export class FormAttributeOptions {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => FormAttributeChoice),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], FormAttributeOptions.prototype, "choices", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FormAttributeOptions.prototype, "expanded", void 0);
__decorate([
    ValidateNested(),
    Type(() => FormAttributeCondition),
    IsOptional(),
    __metadata("design:type", FormAttributeCondition)
], FormAttributeOptions.prototype, "hide_when", void 0);
__decorate([
    ValidateNested(),
    Type(() => FormAttributeShowWhen),
    IsOptional(),
    __metadata("design:type", FormAttributeShowWhen)
], FormAttributeOptions.prototype, "show_when", void 0);
__decorate([
    ValidateNested(),
    Type(() => FormAttributeInfoVacationDays),
    IsOptional(),
    __metadata("design:type", FormAttributeInfoVacationDays)
], FormAttributeOptions.prototype, "info", void 0);
__decorate([
    ValidateNested(),
    Type(() => FormAttributeTooltip),
    IsOptional(),
    __metadata("design:type", FormAttributeTooltip)
], FormAttributeOptions.prototype, "tooltip", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormAttributeOptions.prototype, "placeholder", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormAttributeOptions.prototype, "format", void 0);
__decorate([
    IsIn(['S', 'M', 'L']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormAttributeOptions.prototype, "size", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FormAttributeOptions.prototype, "ocr", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FormAttributeOptions.prototype, "qrcode", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FormAttributeOptions.prototype, "is_multiple", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FormAttributeOptions.prototype, "single_selection", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormAttributeOptions.prototype, "expression", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", Object)
], FormAttributeOptions.prototype, "expression_aliases", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormAttributeOptions.prototype, "alias", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], FormAttributeOptions.prototype, "decimals", void 0);
__decorate([
    IsIn([
        'percentage_employee',
        'percentage_manager',
        'actions',
        'obstacles',
        'supporting_docs',
        'justification',
    ], { each: true }),
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], FormAttributeOptions.prototype, "editable_fields", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], FormAttributeOptions.prototype, "max_length", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], FormAttributeOptions.prototype, "min_length", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FormAttributeOptions.prototype, "select_leaf_only", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FormAttributeOptions.prototype, "validate_not_editable", void 0);
__decorate([
    IsIn(['original_vacation_days']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormAttributeOptions.prototype, "info_type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormAttributeOptions.prototype, "catalog_name", void 0);
export class FormAttribute {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormAttribute.prototype, "id", void 0);
__decorate([
    IsIn([
        'text',
        'textarea',
        'date',
        'datetime',
        'file',
        'file_multiple',
        'choice',
        'year',
        'text_catalog',
        'url',
        'text_fixed_catalog',
        'staff_position',
        'goals',
        'goals_change',
        'goals_review',
        'goals_final_review',
        'employee',
        'fns_verification',
        'address_catalog',
        'hierarchic_catalog',
        'orgstructure_catalog',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormAttribute.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FormAttribute.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormAttribute.prototype, "description", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], FormAttribute.prototype, "required", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FormAttribute.prototype, "read_only", void 0);
__decorate([
    IsIn(['esia']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FormAttribute.prototype, "label_icon", void 0);
__decorate([
    ValidateNested(),
    Type(() => FormAttributeOptions),
    IsOptional(),
    __metadata("design:type", FormAttributeOptions)
], FormAttribute.prototype, "options", void 0);
export class NodeAction {
}
__decorate([
    IsIn([
        'kontur',
        'goskey',
        'cryptopro_simple',
        'cryptopro_local',
        'disabled',
        'ukep',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], NodeAction.prototype, "unep_type", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], NodeAction.prototype, "unep_type_substituted", void 0);
__decorate([
    ValidateNested(),
    Type(() => KonturSystemDown),
    IsOptional(),
    __metadata("design:type", KonturSystemDown)
], NodeAction.prototype, "kontur_system_down", void 0);
__decorate([
    IsIn(['sms', 'no_sms']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], NodeAction.prototype, "two_factor_auth", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], NodeAction.prototype, "failed", void 0);
__decorate([
    IsIn(['new', 'processing', 'canceled', 'error']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], NodeAction.prototype, "signature_status", void 0);
__decorate([
    IsIn(['snils_not_found']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], NodeAction.prototype, "signature_detailed_error", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], NodeAction.prototype, "name", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], NodeAction.prototype, "is_primary", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], NodeAction.prototype, "is_employee", void 0);
__decorate([
    IsIn([
        'upload',
        'upload_batch',
        'accept',
        'ukep_sign',
        'ukep_sign_batch',
        'unep_sign',
        'unep_sign_batch',
        'pep_sign',
        'pep_sign_batch',
        'generate_document_from_template',
        'decline',
        'decline_sign',
        'return',
        'competency_eval',
        'competency_profile',
        'competency_fill',
        'system',
        'system_validate_sign',
        'system_set_vacation_days',
        'system_sync_scheduled_vacations',
        'system_booking_hook',
        'system_booking_approve',
        'system_booking_limits_exceeded_approve',
        'system_booking_trip_create',
        'system_linkedtrip_attrinfo',
        'system_linkedtrip_approveinfo',
        'system_booking_trip_info',
        'system_booking_trip_change',
        'system_booking_trip_ordering',
        'system_booking_trip_limit',
        'system_booking_trip_limit_approved',
        'system_business_trip_file_delivery',
        'system_deadline',
        'system_condition_positive',
        'system_condition_negative',
        'system_condition_0',
        'system_condition_1',
        'system_condition_2',
        'system_condition_3',
        'system_condition_4',
        'system_condition_5',
        'system_condition_6',
        'system_condition_7',
        'system_condition_8',
        'system_condition_9',
        'system_create_request_sw',
        'system_trip_info_sw',
        'system_item_voucher_sw',
        'system_cancel_request_sw',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], NodeAction.prototype, "type", void 0);
__decorate([
    ValidateNested(),
    Type(() => Document),
    IsOptional(),
    __metadata("design:type", Document)
], NodeAction.prototype, "document", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => Document),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], NodeAction.prototype, "documents", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => FormAttribute),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], NodeAction.prototype, "form_attributes", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], NodeAction.prototype, "form_meta", void 0);
__decorate([
    ValidateNested(),
    Type(() => ActionExtra),
    IsOptional(),
    __metadata("design:type", ActionExtra)
], NodeAction.prototype, "extra", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => NodeActionResponsible),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], NodeAction.prototype, "responsible", void 0);
__decorate([
    ValidateNested(),
    Type(() => NodeActionConfirmation),
    IsOptional(),
    __metadata("design:type", NodeActionConfirmation)
], NodeAction.prototype, "confirmation", void 0);
export class EventNode {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventNode.prototype, "node_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventNode.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventNode.prototype, "description", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => NodeAction),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventNode.prototype, "actions", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], EventNode.prototype, "deadline", void 0);
__decorate([
    ValidateNested(),
    Type(() => CustomState),
    IsOptional(),
    __metadata("design:type", CustomState)
], EventNode.prototype, "custom_state", void 0);
export class CanceledDetails {
}
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CanceledDetails.prototype, "canceled_at", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CanceledDetails.prototype, "reason", void 0);
__decorate([
    IsIn([
        'node_deadline',
        'event_deadline',
        'manual_employee',
        'manual_company',
        'dismiss',
        'workflow_change',
        'manual_pgo_periods_not_found',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CanceledDetails.prototype, "reason_type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CanceledDetails.prototype, "document_type_name", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CanceledDetails.prototype, "node_name", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CanceledDetails.prototype, "responsible", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], CanceledDetails.prototype, "can_restore", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CanceledDetails.prototype, "comment", void 0);
export class Action {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Action.prototype, "name", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], Action.prototype, "failed", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Action.prototype, "retry_text", void 0);
__decorate([
    IsIn([
        'upload',
        'accept',
        'ukep_sign',
        'ukep_sign_batch',
        'unep_sign',
        'unep_sign_batch',
        'pep_sign',
        'pep_sign_batch',
        'system',
        'system_validate_sign',
        'system_delete_attributes',
        'generate_document_from_template',
        'decline',
        'decline_sign',
        'canceled_to_paper',
        'in_paper',
        'completed',
        'canceled',
        'declined',
        'declined_sign',
        'competency_eval',
        'competency_profile',
        'competency_fill',
        'system_complete_candidate',
        'system_booking_hook',
        'system_booking_approve',
        'system_booking_limits_exceeded_approve',
        'system_booking_trip_create',
        'system_linkedtrip_attrinfo',
        'system_linkedtrip_approveinfo',
        'system_booking_trip_info',
        'system_booking_trip_change',
        'system_booking_trip_cancel',
        'system_booking_trip_ordering',
        'system_booking_trip_limit',
        'system_booking_trip_limit_approved',
        'system_business_trip_file_delivery',
        'system_linkedtrip_approveinfo',
        'system_linkedtrip_attrinfo',
        'system_set_vacation_days',
        'system_sync_scheduled_vacations',
        'system_deadline',
        'system_create_request_sw',
        'system_trip_info_sw',
        'system_item_voucher_sw',
        'system_cancel_request_sw',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Action.prototype, "type", void 0);
export class ActiveNode {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ActiveNode.prototype, "node_id", void 0);
__decorate([
    ValidateNested(),
    Type(() => Action),
    IsNotEmpty(),
    __metadata("design:type", Action)
], ActiveNode.prototype, "action", void 0);
__decorate([
    ValidateNested(),
    Type(() => CustomState),
    IsOptional(),
    __metadata("design:type", CustomState)
], ActiveNode.prototype, "custom_state", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ActiveNode.prototype, "responsible", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], ActiveNode.prototype, "document_type_names", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ActiveNode.prototype, "is_return", void 0);
export class EventEmployee {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventEmployee.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventEmployee.prototype, "personnel_number", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], EventEmployee.prototype, "birthday", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventEmployee.prototype, "first_name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventEmployee.prototype, "second_name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventEmployee.prototype, "middle_name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventEmployee.prototype, "unit", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventEmployee.prototype, "legal_unit", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventEmployee.prototype, "position", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], EventEmployee.prototype, "dismissed_at", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventEmployee.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventEmployee.prototype, "email", void 0);
export class TimeRange {
}
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], TimeRange.prototype, "start", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], TimeRange.prototype, "end", void 0);
export class EventTypeItemChild_button {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventTypeItemChild_button.prototype, "is_active", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => TimeRange),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventTypeItemChild_button.prototype, "active_periods", void 0);
export class EventTypeItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventTypeItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventTypeItem.prototype, "name", void 0);
__decorate([
    IsIn(['item']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventTypeItem.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventTypeItem.prototype, "custom_type", void 0);
__decorate([
    IsIn(['employee', 'candidate', 'vacation']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventTypeItem.prototype, "category", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EventTypeItem.prototype, "document_info_required", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventTypeItem.prototype, "disabled", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventTypeItem.prototype, "tags", void 0);
__decorate([
    ValidateNested(),
    Type(() => EventTypeItemChild_button),
    IsOptional(),
    __metadata("design:type", EventTypeItemChild_button)
], EventTypeItem.prototype, "child_button", void 0);
export class Event {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Event.prototype, "id", void 0);
__decorate([
    ValidateNested(),
    Type(() => EventTypeItem),
    IsNotEmpty(),
    __metadata("design:type", EventTypeItem)
], Event.prototype, "event_type", void 0);
__decorate([
    ValidateNested(),
    Type(() => EventEmployee),
    IsOptional(),
    __metadata("design:type", EventEmployee)
], Event.prototype, "employee", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompanyItem),
    IsNotEmpty(),
    __metadata("design:type", CompanyItem)
], Event.prototype, "company", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Event.prototype, "created_at", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => ActiveNode),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], Event.prototype, "active_nodes", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], Event.prototype, "deadline", void 0);
__decorate([
    ValidateNested(),
    Type(() => CanceledDetails),
    IsOptional(),
    __metadata("design:type", CanceledDetails)
], Event.prototype, "canceled", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], Event.prototype, "signed_after_cancel", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], Event.prototype, "signed_after_skip", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Event.prototype, "active_unifying_status_name", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], Event.prototype, "parent_event_id", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], Event.prototype, "children_events_count", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventNode),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], Event.prototype, "nodes", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventNode),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], Event.prototype, "current_nodes", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => Document),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], Event.prototype, "documents", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => Attribute),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], Event.prototype, "attributes", void 0);
__decorate([
    ValidateNested(),
    Type(() => BusinessTripRoute),
    IsOptional(),
    __metadata("design:type", BusinessTripRoute)
], Event.prototype, "business_trip_route", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], Event.prototype, "attributes_meta", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventParticipant),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], Event.prototype, "participants", void 0);
__decorate([
    ValidateNested(),
    Type(() => EventPermissions),
    IsNotEmpty(),
    __metadata("design:type", EventPermissions)
], Event.prototype, "permissions", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventComment),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], Event.prototype, "comments", void 0);
__decorate([
    ValidateNested(),
    Type(() => EventOptions),
    IsOptional(),
    __metadata("design:type", EventOptions)
], Event.prototype, "options", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventCompetencyGroup),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], Event.prototype, "competency_groups", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Event.prototype, "consecutive_number", void 0);
export class ScheduleEvent {
}
__decorate([
    ValidateNested(),
    Type(() => Event),
    IsNotEmpty(),
    __metadata("design:type", Event)
], ScheduleEvent.prototype, "event", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], ScheduleEvent.prototype, "schedule_year", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ScheduleEvent.prototype, "schedule_id", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], ScheduleEvent.prototype, "favorites_allowed", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => ImportedAbsenceItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], ScheduleEvent.prototype, "imported_absences", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ScheduleEvent.prototype, "return_disabled", void 0);
export class FilterSelectBadge {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterSelectBadge.prototype, "title", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FilterSelectBadge.prototype, "description", void 0);
__decorate([
    IsIn(['blue', 'velvet', 'red']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FilterSelectBadge.prototype, "color", void 0);
__decorate([
    IsIn(['left', 'bottom']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FilterSelectBadge.prototype, "position", void 0);
export class FilterSelectOption {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterSelectOption.prototype, "value", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterSelectOption.prototype, "label", void 0);
__decorate([
    IsIn(['item']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FilterSelectOption.prototype, "type", void 0);
__decorate([
    ValidateNested(),
    Type(() => FilterSelectBadge),
    IsOptional(),
    __metadata("design:type", FilterSelectBadge)
], FilterSelectOption.prototype, "badge", void 0);
export class FilterGroupOption {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterGroupOption.prototype, "id", void 0);
__decorate([
    IsIn(['group']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterGroupOption.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterGroupOption.prototype, "label", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => FilterSelectOption),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], FilterGroupOption.prototype, "items", void 0);
export class VacationScheduleAvailableFiltersConsecutiveNumberOptionsResponse {
}
export class FilterTimeRange {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterTimeRange.prototype, "key", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterTimeRange.prototype, "name", void 0);
__decorate([
    IsIn(['timerange']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterTimeRange.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterTimeRange.prototype, "placeholder", void 0);
__decorate([
    IsIn(['till_now', 'any', 'from_now']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterTimeRange.prototype, "allow_dates", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FilterTimeRange.prototype, "hidden", void 0);
export class FilterBool {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterBool.prototype, "key", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterBool.prototype, "name", void 0);
__decorate([
    IsIn(['bool']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterBool.prototype, "type", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FilterBool.prototype, "hidden", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], FilterBool.prototype, "tooltip", void 0);
export class FilterMultipleSearch {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterMultipleSearch.prototype, "key", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterMultipleSearch.prototype, "name", void 0);
__decorate([
    IsIn(['multiple-search']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterMultipleSearch.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterMultipleSearch.prototype, "url", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterMultipleSearch.prototype, "placeholder", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FilterMultipleSearch.prototype, "hidden", void 0);
export class FilterSearch {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterSearch.prototype, "key", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterSearch.prototype, "name", void 0);
__decorate([
    IsIn(['search']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterSearch.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterSearch.prototype, "url", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterSearch.prototype, "placeholder", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FilterSearch.prototype, "disable_if_one_option", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FilterSearch.prototype, "hidden", void 0);
export class FilterText {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterText.prototype, "key", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterText.prototype, "name", void 0);
__decorate([
    IsIn(['text']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterText.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterText.prototype, "placeholder", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FilterText.prototype, "hidden", void 0);
export class FilterMultiple {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterMultiple.prototype, "key", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterMultiple.prototype, "name", void 0);
__decorate([
    IsIn(['multiple']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterMultiple.prototype, "type", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => FilterSelectOption),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], FilterMultiple.prototype, "options", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterMultiple.prototype, "placeholder", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FilterMultiple.prototype, "disable_if_one_option", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FilterMultiple.prototype, "hidden", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FilterMultiple.prototype, "autocomplete", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FilterMultiple.prototype, "clearable", void 0);
export class FilterSelect {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterSelect.prototype, "key", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterSelect.prototype, "name", void 0);
__decorate([
    IsIn(['select']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterSelect.prototype, "type", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => FilterSelectOption),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], FilterSelect.prototype, "options", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], FilterSelect.prototype, "placeholder", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FilterSelect.prototype, "autocomplete", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FilterSelect.prototype, "disable_if_one_option", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], FilterSelect.prototype, "hidden", void 0);
export class ScheduleEventAvailableFilters {
}
__decorate([
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], ScheduleEventAvailableFilters.prototype, "filters", void 0);
export class ScheduleEmployee {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ScheduleEmployee.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ScheduleEmployee.prototype, "personnel_number", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ScheduleEmployee.prototype, "position", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ScheduleEmployee.prototype, "first_name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ScheduleEmployee.prototype, "second_name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ScheduleEmployee.prototype, "middle_name", void 0);
export class ScheduleManager {
}
__decorate([
    ValidateNested(),
    Type(() => ScheduleEmployee),
    IsNotEmpty(),
    __metadata("design:type", ScheduleEmployee)
], ScheduleManager.prototype, "employee", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ScheduleManager.prototype, "type_name", void 0);
export class UnitScheduleItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitScheduleItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UnitScheduleItem.prototype, "name", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], UnitScheduleItem.prototype, "parent_id", void 0);
__decorate([
    ValidateNested(),
    Type(() => ScheduleManager),
    IsOptional(),
    __metadata("design:type", ScheduleManager)
], UnitScheduleItem.prototype, "manager", void 0);
export class VacationItem {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], VacationItem.prototype, "type_name", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], VacationItem.prototype, "from_date", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], VacationItem.prototype, "to_date", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], VacationItem.prototype, "intersections_count", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], VacationItem.prototype, "compensatory", void 0);
export class ScheduleEventParticipant {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ScheduleEventParticipant.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ScheduleEventParticipant.prototype, "data", void 0);
export class ReturnEventAction {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ReturnEventAction.prototype, "node_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], ReturnEventAction.prototype, "message_attr_id", void 0);
export class AcceptEventAction {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AcceptEventAction.prototype, "node_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], AcceptEventAction.prototype, "message_attr_id", void 0);
export class EventActions {
}
__decorate([
    ValidateNested(),
    Type(() => AcceptEventAction),
    IsOptional(),
    __metadata("design:type", AcceptEventAction)
], EventActions.prototype, "accept_action", void 0);
__decorate([
    ValidateNested(),
    Type(() => ReturnEventAction),
    IsOptional(),
    __metadata("design:type", ReturnEventAction)
], EventActions.prototype, "return_action", void 0);
export class ScheduleEventListItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ScheduleEventListItem.prototype, "id", void 0);
__decorate([
    ValidateNested(),
    Type(() => ScheduleEmployee),
    IsNotEmpty(),
    __metadata("design:type", ScheduleEmployee)
], ScheduleEventListItem.prototype, "employee", void 0);
__decorate([
    ValidateNested(),
    Type(() => WorkScheduleCalendar),
    IsOptional(),
    __metadata("design:type", WorkScheduleCalendar)
], ScheduleEventListItem.prototype, "work_schedule", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], ScheduleEventListItem.prototype, "deadline", void 0);
__decorate([
    ValidateNested(),
    Type(() => EventActions),
    IsOptional(),
    __metadata("design:type", EventActions)
], ScheduleEventListItem.prototype, "actions", void 0);
__decorate([
    ValidateNested(),
    Type(() => ScheduleEventParticipant),
    IsOptional(),
    __metadata("design:type", ScheduleEventParticipant)
], ScheduleEventListItem.prototype, "active_participant", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], ScheduleEventListItem.prototype, "up_to_me", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], ScheduleEventListItem.prototype, "my_event", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], ScheduleEventListItem.prototype, "favorite", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], ScheduleEventListItem.prototype, "unit_id", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => VacationItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], ScheduleEventListItem.prototype, "vacations", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => ImportedAbsenceItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], ScheduleEventListItem.prototype, "imported_absences", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => WorkCalendarDate),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], ScheduleEventListItem.prototype, "calendar_diff", void 0);
__decorate([
    IsIn(['new', 'accept', 'finished', 'canceled', 'onec_sync']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ScheduleEventListItem.prototype, "status", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ScheduleEventListItem.prototype, "consecutive_number", void 0);
export class ScheduleFavoriteEventsListResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => ScheduleEventListItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], ScheduleFavoriteEventsListResponse.prototype, "events", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => UnitScheduleItem),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], ScheduleFavoriteEventsListResponse.prototype, "units", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], ScheduleFavoriteEventsListResponse.prototype, "show_units", void 0);
export class ScheduleEventsXlsxResponse {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ScheduleEventsXlsxResponse.prototype, "download_id", void 0);
export class ScheduleEventsListResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => ScheduleEventListItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], ScheduleEventsListResponse.prototype, "events", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => UnitScheduleItem),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], ScheduleEventsListResponse.prototype, "units", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => AbsenceIntersectionMonth),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], ScheduleEventsListResponse.prototype, "intersections", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], ScheduleEventsListResponse.prototype, "show_units", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], ScheduleEventsListResponse.prototype, "total_count", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], ScheduleEventsListResponse.prototype, "total_count_my", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], ScheduleEventsListResponse.prototype, "total_count_subordinates", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], ScheduleEventsListResponse.prototype, "total_count_all", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], ScheduleEventsListResponse.prototype, "total_count_favorites", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ScheduleEventsListResponse.prototype, "return_disabled", void 0);
export class EventAttributeCacheFileResponse {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventAttributeCacheFileResponse.prototype, "file_id", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventAttributeCacheFileResponse.prototype, "expired_at", void 0);
export class EventFileHash {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventFileHash.prototype, "event_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventFileHash.prototype, "document_id", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventFileHash.prototype, "hash", void 0);
export class GetEventFileHashesResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventFileHash),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetEventFileHashesResponse.prototype, "hashes", void 0);
export class GetEventDocumentFileHashResponse {
}
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventDocumentFileHashResponse.prototype, "hash", void 0);
export class CreateEventBatchDocumentZipResponse {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateEventBatchDocumentZipResponse.prototype, "download_id", void 0);
export class RequestEventDocumentDocxResponse {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], RequestEventDocumentDocxResponse.prototype, "download_id", void 0);
export class BatchEventOperationResponse {
}
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], BatchEventOperationResponse.prototype, "success_count", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], BatchEventOperationResponse.prototype, "error_count", void 0);
export class BatchEventAcceptResponse {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], BatchEventAcceptResponse.prototype, "successes", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], BatchEventAcceptResponse.prototype, "errors", void 0);
export class AvailableDaysCheckValidator {
}
__decorate([
    IsIn(['available_days_check']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AvailableDaysCheckValidator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AvailableDaysCheckValidator.prototype, "days_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AvailableDaysCheckValidator.prototype, "vacation_type_attribute_id", void 0);
__decorate([
    IsIn(['eq', 'ne', 'gt', 'lt', 'ge', 'le']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AvailableDaysCheckValidator.prototype, "operation", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], AvailableDaysCheckValidator.prototype, "vacation_types", void 0);
__decorate([
    IsNotEmpty(),
    __metadata("design:type", Object)
], AvailableDaysCheckValidator.prototype, "available_days_by_type", void 0);
export class LuhnAlgorithmValidator {
}
__decorate([
    IsIn(['luhn_algorithm']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], LuhnAlgorithmValidator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], LuhnAlgorithmValidator.prototype, "attribute_id", void 0);
export class WithoutIntersectionDateCollection {
}
__decorate([
    IsIn(['without_intersection_date_collection']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WithoutIntersectionDateCollection.prototype, "type", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WithoutIntersectionDateCollection.prototype, "from_attribute_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WithoutIntersectionDateCollection.prototype, "to_attribute_id", void 0);
export class CompareDateCollectionValidator {
}
__decorate([
    IsIn(['compare_date_collection']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompareDateCollectionValidator.prototype, "type", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CompareDateCollectionValidator.prototype, "holidays_exclusion", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CompareDateCollectionValidator.prototype, "working_days_only", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompareDateCollectionValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompareDateCollectionValidator.prototype, "to_attribute_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompareDateCollectionValidator.prototype, "length_attribute_id", void 0);
export class AbsenceDaysCheckValidator {
}
__decorate([
    IsIn(['absence_days_check']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceDaysCheckValidator.prototype, "type", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], AbsenceDaysCheckValidator.prototype, "days_check", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], AbsenceDaysCheckValidator.prototype, "working_days_only", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceDaysCheckValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceDaysCheckValidator.prototype, "to_attribute_id", void 0);
export class OnlyCurrentYearValidator {
}
__decorate([
    IsIn(['only_current_year']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], OnlyCurrentYearValidator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], OnlyCurrentYearValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], OnlyCurrentYearValidator.prototype, "to_attribute_id", void 0);
export class CheckValueValidator {
}
__decorate([
    IsIn(['check_value']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CheckValueValidator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CheckValueValidator.prototype, "attribute_id", void 0);
__decorate([
    IsIn(['eq', 'ne', 'gt', 'lt', 'ge', 'le']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CheckValueValidator.prototype, "operation", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CheckValueValidator.prototype, "value", void 0);
export class ValuesCompareValidator {
}
__decorate([
    IsIn(['values_compare']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ValuesCompareValidator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ValuesCompareValidator.prototype, "left_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ValuesCompareValidator.prototype, "right_attribute_id", void 0);
__decorate([
    IsIn(['eq', 'ne', 'gt', 'lt', 'ge', 'le']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ValuesCompareValidator.prototype, "operation", void 0);
export class ExceedingLimitValidator {
}
__decorate([
    IsIn(['exceeding_limit']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ExceedingLimitValidator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ExceedingLimitValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ExceedingLimitValidator.prototype, "to_attribute_id", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], ExceedingLimitValidator.prototype, "vacation_available_days", void 0);
export class AbsenceOverlapItem {
}
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceOverlapItem.prototype, "from_date", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceOverlapItem.prototype, "to_date", void 0);
__decorate([
    IsIn(['error', 'warning']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceOverlapItem.prototype, "action", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceOverlapItem.prototype, "message", void 0);
export class AbsenceOverlapValidator {
}
__decorate([
    IsIn(['has_absence']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceOverlapValidator.prototype, "type", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceOverlapValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AbsenceOverlapValidator.prototype, "to_attribute_id", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => AbsenceOverlapItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], AbsenceOverlapValidator.prototype, "existing_dates", void 0);
export class NonWorkingDaysIncludedCheckValidator {
}
__decorate([
    IsIn(['non_working_days_included_check']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], NonWorkingDaysIncludedCheckValidator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], NonWorkingDaysIncludedCheckValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], NonWorkingDaysIncludedCheckValidator.prototype, "to_attribute_id", void 0);
export class VacationPeriodsValidator {
}
__decorate([
    IsIn(['vacation_periods']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationPeriodsValidator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationPeriodsValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationPeriodsValidator.prototype, "to_attribute_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationPeriodsValidator.prototype, "type_attribute_id", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", Object)
], VacationPeriodsValidator.prototype, "vacations", void 0);
export class VacationMin5daysBetweenNotWorkdaysValidator {
}
__decorate([
    IsIn(['vacation_min_5_days_between_not_workdays']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationMin5daysBetweenNotWorkdaysValidator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationMin5daysBetweenNotWorkdaysValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationMin5daysBetweenNotWorkdaysValidator.prototype, "to_attribute_id", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], VacationMin5daysBetweenNotWorkdaysValidator.prototype, "vacation_types", void 0);
export class VacationLimitToCalculatedDaysValidator {
}
__decorate([
    IsIn(['vacation_limit_to_calculated_days']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationLimitToCalculatedDaysValidator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationLimitToCalculatedDaysValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationLimitToCalculatedDaysValidator.prototype, "to_attribute_id", void 0);
export class VacationSchedule14DaysValidator {
}
__decorate([
    IsIn(['vacation_schedule_14_days']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationSchedule14DaysValidator.prototype, "type", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], VacationSchedule14DaysValidator.prototype, "vacation_types", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationSchedule14DaysValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationSchedule14DaysValidator.prototype, "to_attribute_id", void 0);
export class VacationScheduleAllDaysValidator {
}
__decorate([
    IsIn(['vacation_schedule_all_days']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationScheduleAllDaysValidator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationScheduleAllDaysValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], VacationScheduleAllDaysValidator.prototype, "to_attribute_id", void 0);
export class MinHiringDayValidator {
}
__decorate([
    IsIn(['min_hiring_day']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinHiringDayValidator.prototype, "type", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], MinHiringDayValidator.prototype, "hired_at", void 0);
__decorate([
    IsIn(['eq', 'ne', 'gt', 'lt', 'ge', 'le']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinHiringDayValidator.prototype, "operation", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinHiringDayValidator.prototype, "attribute_id", void 0);
export class MinSpecificWeekendDaysValidator {
}
__decorate([
    IsIn(['min_specific_weekend_days']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinSpecificWeekendDaysValidator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinSpecificWeekendDaysValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinSpecificWeekendDaysValidator.prototype, "to_attribute_id", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], MinSpecificWeekendDaysValidator.prototype, "vacation_types", void 0);
export class MinWeekendDaysValidator {
}
__decorate([
    IsIn(['min_weekend_days']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinWeekendDaysValidator.prototype, "type", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], MinWeekendDaysValidator.prototype, "working_days", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], MinWeekendDaysValidator.prototype, "min_weekend_days", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinWeekendDaysValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinWeekendDaysValidator.prototype, "to_attribute_id", void 0);
__decorate([
    IsNotEmpty(),
    __metadata("design:type", Object)
], MinWeekendDaysValidator.prototype, "vacation_type", void 0);
export class MaxYearValidator {
}
__decorate([
    IsIn(['max_year']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MaxYearValidator.prototype, "type", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], MaxYearValidator.prototype, "max_year", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], MaxYearValidator.prototype, "min_year", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MaxYearValidator.prototype, "attribute_id", void 0);
export class DivisibleByValidator {
}
__decorate([
    IsIn(['divisible_by']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DivisibleByValidator.prototype, "type", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], DivisibleByValidator.prototype, "divisible_by", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DivisibleByValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DivisibleByValidator.prototype, "to_attribute_id", void 0);
export class VacationAvailableValidator {
}
__decorate([
    IsIn(['vacation_available']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], VacationAvailableValidator.prototype, "type", void 0);
__decorate([
    IsNumber(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], VacationAvailableValidator.prototype, "vacation_available_days", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], VacationAvailableValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], VacationAvailableValidator.prototype, "to_attribute_id", void 0);
export class SameMonthValidator {
}
__decorate([
    IsIn(['same_month']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], SameMonthValidator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], SameMonthValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], SameMonthValidator.prototype, "to_attribute_id", void 0);
export class DateRange {
}
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DateRange.prototype, "from_date", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DateRange.prototype, "to_date", void 0);
export class ForbiddenPeriodsValidator {
}
__decorate([
    IsIn(['forbidden_periods']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ForbiddenPeriodsValidator.prototype, "type", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => DateRange),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], ForbiddenPeriodsValidator.prototype, "existing_dates", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ForbiddenPeriodsValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ForbiddenPeriodsValidator.prototype, "to_attribute_id", void 0);
export class NoOverlapValidator {
}
__decorate([
    IsIn(['no_overlap']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], NoOverlapValidator.prototype, "type", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => DateRange),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], NoOverlapValidator.prototype, "existing_dates", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], NoOverlapValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], NoOverlapValidator.prototype, "to_attribute_id", void 0);
export class MaximumDurationValidator {
}
__decorate([
    IsIn(['max_duration']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MaximumDurationValidator.prototype, "type", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], MaximumDurationValidator.prototype, "days_count", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], MaximumDurationValidator.prototype, "working_days_only", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], MaximumDurationValidator.prototype, "ignore_holidays", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", Object)
], MaximumDurationValidator.prototype, "by_vacation_type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MaximumDurationValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MaximumDurationValidator.prototype, "to_attribute_id", void 0);
export class MinimumDurationValidator {
}
__decorate([
    IsIn(['min_duration']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinimumDurationValidator.prototype, "type", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], MinimumDurationValidator.prototype, "days_count", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], MinimumDurationValidator.prototype, "working_days_only", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], MinimumDurationValidator.prototype, "ignore_holidays", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", Object)
], MinimumDurationValidator.prototype, "by_vacation_type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinimumDurationValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinimumDurationValidator.prototype, "to_attribute_id", void 0);
export class HolydaysExclusionCheckValidator {
}
__decorate([
    IsIn(['holydays_exclusion']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], HolydaysExclusionCheckValidator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], HolydaysExclusionCheckValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], HolydaysExclusionCheckValidator.prototype, "to_attribute_id", void 0);
export class WeekendExclusionCheckValidator {
}
__decorate([
    IsIn(['weekend_exclusion']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WeekendExclusionCheckValidator.prototype, "type", void 0);
__decorate([
    IsDateString(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], WeekendExclusionCheckValidator.prototype, "existing_vacations", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WeekendExclusionCheckValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WeekendExclusionCheckValidator.prototype, "to_attribute_id", void 0);
export class WorkingDayCheckValidator {
}
__decorate([
    IsIn(['working_day']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkingDayCheckValidator.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkingDayCheckValidator.prototype, "from_attribute_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], WorkingDayCheckValidator.prototype, "to_attribute_id", void 0);
export class MaxDateValidator {
}
__decorate([
    IsIn(['max_date']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MaxDateValidator.prototype, "type", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MaxDateValidator.prototype, "max_date", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], MaxDateValidator.prototype, "days_count", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], MaxDateValidator.prototype, "working_days_only", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MaxDateValidator.prototype, "attribute_id", void 0);
export class MinDateValidator {
}
__decorate([
    IsIn(['min_date']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinDateValidator.prototype, "type", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinDateValidator.prototype, "min_date", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], MinDateValidator.prototype, "days_count", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], MinDateValidator.prototype, "working_days_only", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], MinDateValidator.prototype, "attribute_id", void 0);
export class NumberValidator {
}
__decorate([
    IsIn(['number']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], NumberValidator.prototype, "type", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], NumberValidator.prototype, "less_than", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], NumberValidator.prototype, "less_than_or_equal", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], NumberValidator.prototype, "greater_than", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], NumberValidator.prototype, "greater_than_or_equal", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], NumberValidator.prototype, "attribute_id", void 0);
export class ValidatorList {
}
export class BatchEventCancelResponse {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], BatchEventCancelResponse.prototype, "successes", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], BatchEventCancelResponse.prototype, "errors", void 0);
export class EventsUkepListResponse {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventsUkepListResponse.prototype, "ids", void 0);
export class BatchEventOperationsInfoResponse {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], BatchEventOperationsInfoResponse.prototype, "optional_attrs_exist", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], BatchEventOperationsInfoResponse.prototype, "total_count_to_accept", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], BatchEventOperationsInfoResponse.prototype, "total_count_to_cancel", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], BatchEventOperationsInfoResponse.prototype, "total_count_to_sign_ukep", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], BatchEventOperationsInfoResponse.prototype, "total_count_to_download", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], BatchEventOperationsInfoResponse.prototype, "batch_operations_limit", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], BatchEventOperationsInfoResponse.prototype, "batch_ukep_sign_limit", void 0);
export class EventOperationsResponse {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventOperationsResponse.prototype, "successes", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventOperationsResponse.prototype, "errors", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], EventOperationsResponse.prototype, "download_id", void 0);
export class EventNodeFlowReturn {
}
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventNodeFlowReturn.prototype, "created_at", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventNodeFlowReturn.prototype, "from_node_id", void 0);
export class Transition {
}
__decorate([
    IsIn([
        'upload',
        'upload_batch',
        'accept',
        'ukep_sign',
        'ukep_sign_batch',
        'unep_sign',
        'unep_sign_batch',
        'pep_sign',
        'pep_sign_batch',
        'generate_document_from_template',
        'decline',
        'decline_sign',
        'return',
        'competency_eval',
        'competency_profile',
        'competency_fill',
        'system',
        'system_validate_sign',
        'system_set_vacation_days',
        'system_sync_scheduled_vacations',
        'system_booking_hook',
        'system_booking_approve',
        'system_booking_limits_exceeded_approve',
        'system_booking_trip_create',
        'system_linkedtrip_attrinfo',
        'system_linkedtrip_approveinfo',
        'system_booking_trip_info',
        'system_booking_trip_change',
        'system_booking_trip_ordering',
        'system_booking_trip_limit',
        'system_booking_trip_limit_approved',
        'system_business_trip_file_delivery',
        'system_deadline',
        'system_condition_positive',
        'system_condition_negative',
        'system_condition_0',
        'system_condition_1',
        'system_condition_2',
        'system_condition_3',
        'system_condition_4',
        'system_condition_5',
        'system_condition_6',
        'system_condition_7',
        'system_condition_8',
        'system_condition_9',
        'system_create_request_sw',
        'system_trip_info_sw',
        'system_item_voucher_sw',
        'system_cancel_request_sw',
    ]),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Transition.prototype, "action_type", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], Transition.prototype, "to_node_id", void 0);
export class EventNodeFlowActor {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventNodeFlowActor.prototype, "role", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventNodeFlowActor.prototype, "fio", void 0);
export class EventNodeFlow {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventNodeFlow.prototype, "node_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventNodeFlow.prototype, "name", void 0);
__decorate([
    IsIn(['finished', 'skipped', 'active', 'canceled', 'inactive']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventNodeFlow.prototype, "status", void 0);
__decorate([
    IsIn([
        'undefined',
        'node_deadline',
        'event_deadline',
        'manual_employee',
        'manual_company',
        'dismiss',
        'workflow_change',
    ]),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventNodeFlow.prototype, "cancel_reason", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventNodeFlow.prototype, "skip_reason", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], EventNodeFlow.prototype, "activity_date", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], EventNodeFlow.prototype, "dismissed_at", void 0);
__decorate([
    IsIn([
        'upload',
        'upload_batch',
        'accept',
        'ukep_sign',
        'ukep_sign_batch',
        'unep_sign',
        'unep_sign_batch',
        'pep_sign',
        'pep_sign_batch',
        'generate_document_from_template',
        'decline',
        'decline_sign',
        'return',
        'competency_eval',
        'competency_profile',
        'competency_fill',
        'system',
        'system_validate_sign',
        'system_set_vacation_days',
        'system_sync_scheduled_vacations',
        'system_booking_hook',
        'system_booking_approve',
        'system_booking_limits_exceeded_approve',
        'system_booking_trip_create',
        'system_linkedtrip_attrinfo',
        'system_linkedtrip_approveinfo',
        'system_booking_trip_info',
        'system_booking_trip_change',
        'system_booking_trip_ordering',
        'system_booking_trip_limit',
        'system_booking_trip_limit_approved',
        'system_business_trip_file_delivery',
        'system_deadline',
        'system_condition_positive',
        'system_condition_negative',
        'system_condition_0',
        'system_condition_1',
        'system_condition_2',
        'system_condition_3',
        'system_condition_4',
        'system_condition_5',
        'system_condition_6',
        'system_condition_7',
        'system_condition_8',
        'system_condition_9',
        'system_create_request_sw',
        'system_trip_info_sw',
        'system_item_voucher_sw',
        'system_cancel_request_sw',
    ]),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventNodeFlow.prototype, "finished_action_type", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], EventNodeFlow.prototype, "deadline", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => NodeAction),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventNodeFlow.prototype, "actions", void 0);
__decorate([
    ValidateNested(),
    Type(() => CustomState),
    IsOptional(),
    __metadata("design:type", CustomState)
], EventNodeFlow.prototype, "custom_state", void 0);
__decorate([
    ValidateNested(),
    Type(() => EventNodeFlowActor),
    IsOptional(),
    __metadata("design:type", EventNodeFlowActor)
], EventNodeFlow.prototype, "actor", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => Transition),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventNodeFlow.prototype, "transitions", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventNodeFlow.prototype, "documents", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventNodeFlow.prototype, "is_optional", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventNodeFlowReturn),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventNodeFlow.prototype, "returns", void 0);
export class EventFlow {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventFlow.prototype, "id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventFlow.prototype, "start_node_id", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventFlow.prototype, "in_paper", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventNodeFlow),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventFlow.prototype, "nodes", void 0);
__decorate([
    IsIn(['employee', 'candidate', 'vacation']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventFlow.prototype, "category", void 0);
export class CreateSimpleEventTypeResponse {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateSimpleEventTypeResponse.prototype, "event_type_id", void 0);
export class CustomTypes {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CustomTypes.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CustomTypes.prototype, "custom_type", void 0);
export class GroupItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GroupItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GroupItem.prototype, "name", void 0);
export class CreateSimpleEventTypeOptionsResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventTypeItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CreateSimpleEventTypeOptionsResponse.prototype, "event_types", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => GroupItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CreateSimpleEventTypeOptionsResponse.prototype, "signature_groups", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => CustomTypes),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CreateSimpleEventTypeOptionsResponse.prototype, "custom_types", void 0);
export class CreateSimpleEventTypeCompany {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateSimpleEventTypeCompany.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateSimpleEventTypeCompany.prototype, "name", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], CreateSimpleEventTypeCompany.prototype, "workflow_change_cancels_events", void 0);
export class CreateSimpleEventTypeCompaniesResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => CreateSimpleEventTypeCompany),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CreateSimpleEventTypeCompaniesResponse.prototype, "companies", void 0);
export class EventAvailableFiltersBusinessTripDestinationOptionsResponse {
}
export class EventAvailableFiltersConsecutiveNumberOptionsResponse {
}
export class AvailableFilters {
}
__decorate([
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], AvailableFilters.prototype, "filters", void 0);
export class EventTypeGroup {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventTypeGroup.prototype, "id", void 0);
__decorate([
    IsIn(['group']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventTypeGroup.prototype, "type", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventTypeGroup.prototype, "label", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventTypeItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventTypeGroup.prototype, "items", void 0);
export class CreateEventOptionsEventTypes {
}
__decorate([
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CreateEventOptionsEventTypes.prototype, "event_types", void 0);
export class CreateEventTypeOptionsCopyAttribute {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateEventTypeOptionsCopyAttribute.prototype, "name", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], CreateEventTypeOptionsCopyAttribute.prototype, "missing", void 0);
export class CreateEventTypeOptionsCopyDocument {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateEventTypeOptionsCopyDocument.prototype, "name", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], CreateEventTypeOptionsCopyDocument.prototype, "missing", void 0);
export class ParticipantItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ParticipantItem.prototype, "group_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ParticipantItem.prototype, "name", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompanyItem),
    IsOptional(),
    __metadata("design:type", CompanyItem)
], ParticipantItem.prototype, "company", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ParticipantItem.prototype, "personnel_number", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ParticipantItem.prototype, "position", void 0);
export class AssignableRole {
}
__decorate([
    ValidateNested(),
    Type(() => RoleItem),
    IsNotEmpty(),
    __metadata("design:type", RoleItem)
], AssignableRole.prototype, "role", void 0);
__decorate([
    IsIn(['group', 'company', 'account', 'manager']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AssignableRole.prototype, "scope", void 0);
__decorate([
    ValidateNested(),
    Type(() => ParticipantItem),
    IsOptional(),
    __metadata("design:type", ParticipantItem)
], AssignableRole.prototype, "default_group", void 0);
export class AssignableRoles {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => AssignableRole),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], AssignableRoles.prototype, "required", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => AssignableRole),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], AssignableRoles.prototype, "optional", void 0);
export class CreateEventTypeOptions {
}
__decorate([
    ValidateNested(),
    Type(() => AssignableRoles),
    IsOptional(),
    __metadata("design:type", AssignableRoles)
], CreateEventTypeOptions.prototype, "assignable_roles", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => CreateEventTypeOptionsCopyDocument),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CreateEventTypeOptions.prototype, "copy_documents", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => CreateEventTypeOptionsCopyAttribute),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CreateEventTypeOptions.prototype, "copy_attributes", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => FormAttribute),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CreateEventTypeOptions.prototype, "form_attributes", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateEventTypeOptions.prototype, "document_required", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateEventTypeOptions.prototype, "add_list_employees", void 0);
export class EmployeesUploadResponse {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EmployeesUploadResponse.prototype, "employee_ids", void 0);
export class BusinessTripPeriod {
}
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], BusinessTripPeriod.prototype, "start_date", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], BusinessTripPeriod.prototype, "end_date", void 0);
export class EventListItemBatch_noticesAccept {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventListItemBatch_noticesAccept.prototype, "optional_attrs_exist", void 0);
export class EventListItemBatch_notices {
}
__decorate([
    ValidateNested(),
    Type(() => EventListItemBatch_noticesAccept),
    IsNotEmpty(),
    __metadata("design:type", EventListItemBatch_noticesAccept)
], EventListItemBatch_notices.prototype, "accept", void 0);
export class EventListItemBatch_operations {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventListItemBatch_operations.prototype, "accept", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventListItemBatch_operations.prototype, "cancel", void 0);
export class CompanySignPermission {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanySignPermission.prototype, "node_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CompanySignPermission.prototype, "document_id", void 0);
export class Permissions {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => CompanySignPermission),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], Permissions.prototype, "company_sign", void 0);
export class DocumentItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DocumentItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DocumentItem.prototype, "document_type_name", void 0);
export class EventListItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventListItem.prototype, "id", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => ActiveNode),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventListItem.prototype, "active_nodes", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], EventListItem.prototype, "days_on_node", void 0);
__decorate([
    ValidateNested(),
    Type(() => EventTypeItem),
    IsNotEmpty(),
    __metadata("design:type", EventTypeItem)
], EventListItem.prototype, "event_type", void 0);
__decorate([
    ValidateNested(),
    Type(() => EventEmployee),
    IsOptional(),
    __metadata("design:type", EventEmployee)
], EventListItem.prototype, "employee", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompanyItem),
    IsNotEmpty(),
    __metadata("design:type", CompanyItem)
], EventListItem.prototype, "company", void 0);
__decorate([
    IsDateString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventListItem.prototype, "created_at", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => DocumentItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventListItem.prototype, "documents", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], EventListItem.prototype, "deadline", void 0);
__decorate([
    ValidateNested(),
    Type(() => Permissions),
    IsNotEmpty(),
    __metadata("design:type", Permissions)
], EventListItem.prototype, "permissions", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => Attribute),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventListItem.prototype, "attributes", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventListItem.prototype, "report_status", void 0);
__decorate([
    ValidateNested(),
    Type(() => EventListItemBatch_operations),
    IsNotEmpty(),
    __metadata("design:type", EventListItemBatch_operations)
], EventListItem.prototype, "batch_operations", void 0);
__decorate([
    ValidateNested(),
    Type(() => EventListItemBatch_notices),
    IsNotEmpty(),
    __metadata("design:type", EventListItemBatch_notices)
], EventListItem.prototype, "batch_notices", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventListItem.prototype, "consecutive_number", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EventListItem.prototype, "is_urgent", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventListItem.prototype, "business_trip_destination", void 0);
__decorate([
    ValidateNested(),
    Type(() => BusinessTripPeriod),
    IsOptional(),
    __metadata("design:type", BusinessTripPeriod)
], EventListItem.prototype, "business_trip_period", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], EventListItem.prototype, "business_trip_days_total", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], EventListItem.prototype, "business_trip_weekend_days", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventListItem.prototype, "deadline_tooltip", void 0);
export class EmployeeCompetencyEventsResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventListItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EmployeeCompetencyEventsResponse.prototype, "competency_events", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EmployeeCompetencyEventsResponse.prototype, "total_count", void 0);
export class EmployeeCompetency {
}
__decorate([
    ValidateNested(),
    Type(() => CompetencyItem),
    IsNotEmpty(),
    __metadata("design:type", CompetencyItem)
], EmployeeCompetency.prototype, "competency", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => CompetencyScaleValue),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EmployeeCompetency.prototype, "scale_values", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompetencyScaleValue),
    IsOptional(),
    __metadata("design:type", CompetencyScaleValue)
], EmployeeCompetency.prototype, "required_level", void 0);
__decorate([
    ValidateNested(),
    Type(() => CompetencyScaleValue),
    IsOptional(),
    __metadata("design:type", CompetencyScaleValue)
], EmployeeCompetency.prototype, "actual_level", void 0);
export class EmployeeCompetencyGroup {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeeCompetencyGroup.prototype, "name", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EmployeeCompetency),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EmployeeCompetencyGroup.prototype, "competencies", void 0);
export class EmployeeCompetencyResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventListItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EmployeeCompetencyResponse.prototype, "competency_events", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => EmployeeCompetencyGroup),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EmployeeCompetencyResponse.prototype, "competency_groups", void 0);
export class EmployeeCreatableEventTypes {
}
__decorate([
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EmployeeCreatableEventTypes.prototype, "event_types", void 0);
export class EmployeesList {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => EmployeeItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EmployeesList.prototype, "employees", void 0);
export class CreateEventTypeParticipantOptions {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => ParticipantItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CreateEventTypeParticipantOptions.prototype, "options", void 0);
export class CreateEventCompanyItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateEventCompanyItem.prototype, "company_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateEventCompanyItem.prototype, "company_name", void 0);
export class CreateEventCompanyOptionsList {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => CreateEventCompanyItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CreateEventCompanyOptionsList.prototype, "items", void 0);
export class CreateEventCommonOptionsResponse {
}
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], CreateEventCommonOptionsResponse.prototype, "has_batch", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], CreateEventCommonOptionsResponse.prototype, "creator_for_others", void 0);
export class EventListCountsResponse {
}
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EventListCountsResponse.prototype, "total_count", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], EventListCountsResponse.prototype, "total_count_my", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], EventListCountsResponse.prototype, "total_count_my_group", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], EventListCountsResponse.prototype, "total_count_from_me", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], EventListCountsResponse.prototype, "total_count_all", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], EventListCountsResponse.prototype, "finished_count", void 0);
export class EventListToPaperResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventListItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventListToPaperResponse.prototype, "events", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EventListToPaperResponse.prototype, "total_count", void 0);
export class EventDocumentCountResponse {
}
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EventDocumentCountResponse.prototype, "total_count", void 0);
export class EventPdfResponse {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventPdfResponse.prototype, "download_id", void 0);
export class EventXlsxResponse {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventXlsxResponse.prototype, "download_id", void 0);
export class EventListResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventListItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventListResponse.prototype, "events", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventListResponse.prototype, "parent_event_tags", void 0);
export class CandidateEventListResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventListItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CandidateEventListResponse.prototype, "events", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], CandidateEventListResponse.prototype, "total_count", void 0);
export class EventBatchEmployeeCountResponse {
}
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EventBatchEmployeeCountResponse.prototype, "total", void 0);
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], EventBatchEmployeeCountResponse.prototype, "allowed", void 0);
export class EventBatchEmployee {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventBatchEmployee.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventBatchEmployee.prototype, "personnel_number", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventBatchEmployee.prototype, "name", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], EventBatchEmployee.prototype, "enabled", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventBatchEmployee.prototype, "position", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventBatchEmployee.prototype, "unit_name", void 0);
export class EventBatchEmployeesResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventBatchEmployee),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventBatchEmployeesResponse.prototype, "employees", void 0);
export class CreateEventBatchResponse {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateEventBatchResponse.prototype, "event_batch_id", void 0);
export class EventBatchItem {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventBatchItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventBatchItem.prototype, "name", void 0);
export class EventBatchListResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => EventBatchItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], EventBatchListResponse.prototype, "event_batches", void 0);
export class CreateEventResponse {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateEventResponse.prototype, "event_id", void 0);
export class CancelReasonItem {
}
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], CancelReasonItem.prototype, "id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CancelReasonItem.prototype, "description", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], CancelReasonItem.prototype, "batch_cancel_enabled", void 0);
export class CancelReasonListResponse {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => CancelReasonItem),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CancelReasonListResponse.prototype, "reasons", void 0);
export class ScheduleEventsListFilters {
}
__decorate([
    IsIn(['my', 'subordinates', 'all', 'favorites']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ScheduleEventsListFilters.prototype, "actor", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], ScheduleEventsListFilters.prototype, "employee_ids", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], ScheduleEventsListFilters.prototype, "unit_ids", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ScheduleEventsListFilters.prototype, "include_subunits", void 0);
__decorate([
    IsIn(['new', 'accept', 'finished', 'canceled', 'onec_sync'], { each: true }),
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], ScheduleEventsListFilters.prototype, "status", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], ScheduleEventsListFilters.prototype, "active_participant", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], ScheduleEventsListFilters.prototype, "event_ids", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], ScheduleEventsListFilters.prototype, "month", void 0);
export class ScheduleEventsXlsxRequest {
}
__decorate([
    ValidateNested(),
    Type(() => ScheduleEventsListFilters),
    IsOptional(),
    __metadata("design:type", ScheduleEventsListFilters)
], ScheduleEventsXlsxRequest.prototype, "filters", void 0);
export class Pagination {
}
__decorate([
    IsIn(['created_at', 'consecutive_number', 'business_trip_start_date']),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Pagination.prototype, "sort_by", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Pagination.prototype, "sort_order", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], Pagination.prototype, "limit", void 0);
__decorate([
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], Pagination.prototype, "offset", void 0);
export class ScheduleEventsListRequest {
}
__decorate([
    ValidateNested(),
    Type(() => Pagination),
    IsOptional(),
    __metadata("design:type", Pagination)
], ScheduleEventsListRequest.prototype, "pagination", void 0);
__decorate([
    ValidateNested(),
    Type(() => ScheduleEventsListFilters),
    IsOptional(),
    __metadata("design:type", ScheduleEventsListFilters)
], ScheduleEventsListRequest.prototype, "filters", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], ScheduleEventsListRequest.prototype, "last_event_id", void 0);
export class EventAttributeCacheFileRequest {
}
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    Type(() => String),
    IsNotEmpty(),
    __metadata("design:type", File)
], EventAttributeCacheFileRequest.prototype, "file", void 0);
export class GetEventFileHashesRequestHashes {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], GetEventFileHashesRequestHashes.prototype, "event_id", void 0);
export class GetEventFileHashesRequest {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => GetEventFileHashesRequestHashes),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], GetEventFileHashesRequest.prototype, "hashes", void 0);
export class CreateEventBatchDocumentZipRequest {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CreateEventBatchDocumentZipRequest.prototype, "event_ids", void 0);
__decorate([
    IsBoolean(),
    IsNotEmpty(),
    __metadata("design:type", Boolean)
], CreateEventBatchDocumentZipRequest.prototype, "with_file_attributes", void 0);
export class CompetencyProfileRequest {
}
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CompetencyProfileRequest.prototype, "competency_values", void 0);
__decorate([
    IsNotEmpty(),
    __metadata("design:type", Object)
], CompetencyProfileRequest.prototype, "attributes", void 0);
export class CompetencyEvalRequest {
}
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CompetencyEvalRequest.prototype, "competency_values", void 0);
__decorate([
    IsNotEmpty(),
    __metadata("design:type", Object)
], CompetencyEvalRequest.prototype, "attributes", void 0);
export class BatchEventReturn {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], BatchEventReturn.prototype, "event_id", void 0);
export class BatchReturnRequest {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => BatchEventReturn),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], BatchReturnRequest.prototype, "events", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BatchReturnRequest.prototype, "comment", void 0);
export class BatchEventAccept {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], BatchEventAccept.prototype, "event_id", void 0);
export class BatchAcceptRequest {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => BatchEventAccept),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], BatchAcceptRequest.prototype, "events", void 0);
export class PepSignEvent {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], PepSignEvent.prototype, "event_id", void 0);
export class PepBatchSignRequest {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => PepSignEvent),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], PepBatchSignRequest.prototype, "events", void 0);
export class PepSignRequest {
}
__decorate([
    IsNotEmpty(),
    __metadata("design:type", Object)
], PepSignRequest.prototype, "attributes", void 0);
export class UkepSignDocument {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UkepSignDocument.prototype, "document_hash", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UkepSignDocument.prototype, "signature", void 0);
export class UkepSignEvent {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UkepSignEvent.prototype, "event_id", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => UkepSignDocument),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], UkepSignEvent.prototype, "documents", void 0);
export class UkepBatchSignRequest {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => UkepSignEvent),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], UkepBatchSignRequest.prototype, "events", void 0);
export class UkepSignRequest {
}
__decorate([
    IsNotEmpty(),
    __metadata("design:type", Object)
], UkepSignRequest.prototype, "attributes", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UkepSignRequest.prototype, "hash", void 0);
export class UnepSignRequest {
}
__decorate([
    IsNotEmpty(),
    __metadata("design:type", Object)
], UnepSignRequest.prototype, "attributes", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UnepSignRequest.prototype, "code", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    IsOptional(),
    __metadata("design:type", Object)
], UnepSignRequest.prototype, "signatures", void 0);
export class GenerateDocumentRequest {
}
__decorate([
    IsNotEmpty(),
    __metadata("design:type", Object)
], GenerateDocumentRequest.prototype, "attributes", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], GenerateDocumentRequest.prototype, "document_date", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GenerateDocumentRequest.prototype, "document_number", void 0);
export class DeclineSignRequest {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], DeclineSignRequest.prototype, "comment", void 0);
__decorate([
    IsNotEmpty(),
    __metadata("design:type", Object)
], DeclineSignRequest.prototype, "attributes", void 0);
export class DeclineRequest {
}
__decorate([
    IsNotEmpty(),
    __metadata("design:type", Object)
], DeclineRequest.prototype, "attributes", void 0);
export class AcceptRequest {
}
__decorate([
    IsNotEmpty(),
    __metadata("design:type", Object)
], AcceptRequest.prototype, "attributes", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AcceptRequest.prototype, "signature", void 0);
export class ReturnRequest {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ReturnRequest.prototype, "comment", void 0);
export class UploadBatchDocument {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UploadBatchDocument.prototype, "node_id", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], UploadBatchDocument.prototype, "document_date", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UploadBatchDocument.prototype, "document_number", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    Type(() => String),
    IsNotEmpty(),
    __metadata("design:type", File)
], UploadBatchDocument.prototype, "document", void 0);
export class UploadBatchRequest {
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => UploadBatchDocument),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], UploadBatchRequest.prototype, "documents", void 0);
export class UploadRequest {
}
__decorate([
    IsNotEmpty(),
    __metadata("design:type", Object)
], UploadRequest.prototype, "attributes", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], UploadRequest.prototype, "document_date", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UploadRequest.prototype, "document_number", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    Type(() => String),
    IsNotEmpty(),
    __metadata("design:type", File)
], UploadRequest.prototype, "document", void 0);
export class ToPaperRequest {
}
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], ToPaperRequest.prototype, "events", void 0);
export class CancelEventRequest {
}
__decorate([
    IsInt(),
    IsNotEmpty(),
    __metadata("design:type", Number)
], CancelEventRequest.prototype, "reason_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CancelEventRequest.prototype, "comment", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CancelEventRequest.prototype, "signature", void 0);
export class BatchCancelRequest {
}
export class EventListRequestFilters {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventListRequestFilters.prototype, "actor", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventListRequestFilters.prototype, "event_type_groups", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventListRequestFilters.prototype, "company", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventListRequestFilters.prototype, "unit_ids", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EventListRequestFilters.prototype, "include_subunits", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventListRequestFilters.prototype, "employee_ids", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventListRequestFilters.prototype, "personnel_number", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventListRequestFilters.prototype, "employee_positions", void 0);
__decorate([
    ValidateNested(),
    Type(() => TimeRange),
    IsOptional(),
    __metadata("design:type", TimeRange)
], EventListRequestFilters.prototype, "finished_at", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventListRequestFilters.prototype, "status", void 0);
__decorate([
    IsIn([
        'deadline',
        'manual_employee',
        'on_employee_before',
        'on_employee_after',
        'manual_company',
        'workflow_change',
        'dismiss',
        'manual_pgo_periods_not_found',
    ], { each: true }),
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventListRequestFilters.prototype, "cancel_reason_type", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventListRequestFilters.prototype, "event_batch_ids", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventListRequestFilters.prototype, "side", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventListRequestFilters.prototype, "segments", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventListRequestFilters.prototype, "document_type", void 0);
__decorate([
    ValidateNested(),
    Type(() => TimeRange),
    IsOptional(),
    __metadata("design:type", TimeRange)
], EventListRequestFilters.prototype, "deadline", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], EventListRequestFilters.prototype, "parent_event_id", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventListRequestFilters.prototype, "tags", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], EventListRequestFilters.prototype, "collection_id", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventListRequestFilters.prototype, "event_ids", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventListRequestFilters.prototype, "consecutive_number", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EventListRequestFilters.prototype, "on_returned_node", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventListRequestFilters.prototype, "attr_absence_type", void 0);
__decorate([
    ValidateNested(),
    Type(() => TimeRange),
    IsOptional(),
    __metadata("design:type", TimeRange)
], EventListRequestFilters.prototype, "attr_absence_start_date", void 0);
__decorate([
    ValidateNested(),
    Type(() => TimeRange),
    IsOptional(),
    __metadata("design:type", TimeRange)
], EventListRequestFilters.prototype, "attr_absence_end_date", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventListRequestFilters.prototype, "attr_vacation_compensation", void 0);
__decorate([
    ValidateNested(),
    Type(() => TimeRange),
    IsOptional(),
    __metadata("design:type", TimeRange)
], EventListRequestFilters.prototype, "attr_goals_dates", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventListRequestFilters.prototype, "business_trip_destination", void 0);
__decorate([
    ValidateNested(),
    Type(() => TimeRange),
    IsOptional(),
    __metadata("design:type", TimeRange)
], EventListRequestFilters.prototype, "business_trip_start_date", void 0);
__decorate([
    ValidateNested(),
    Type(() => TimeRange),
    IsOptional(),
    __metadata("design:type", TimeRange)
], EventListRequestFilters.prototype, "business_trip_end_date", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EventListRequestFilters.prototype, "has_business_trip_weekend_days", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], EventListRequestFilters.prototype, "absences_report_status", void 0);
export class EventsUkepListRequest {
}
__decorate([
    ValidateNested(),
    Type(() => EventListRequestFilters),
    IsOptional(),
    __metadata("design:type", EventListRequestFilters)
], EventsUkepListRequest.prototype, "filters", void 0);
export class EventListRequest {
}
__decorate([
    ValidateNested(),
    Type(() => Pagination),
    IsOptional(),
    __metadata("design:type", Pagination)
], EventListRequest.prototype, "pagination", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], EventListRequest.prototype, "urgent_first", void 0);
__decorate([
    ValidateNested(),
    Type(() => EventListRequestFilters),
    IsOptional(),
    __metadata("design:type", EventListRequestFilters)
], EventListRequest.prototype, "filters", void 0);
export class EventOperationsRequest {
}
__decorate([
    ValidateNested(),
    Type(() => EventListRequestFilters),
    IsOptional(),
    __metadata("design:type", EventListRequestFilters)
], EventOperationsRequest.prototype, "filters", void 0);
__decorate([
    IsIn(['batch_accept', 'batch_cancel', 'batch_download']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventOperationsRequest.prototype, "operation", void 0);
__decorate([
    ValidateNested(),
    Type(() => CancelEventRequest),
    IsOptional(),
    __metadata("design:type", CancelEventRequest)
], EventOperationsRequest.prototype, "cancel_payload", void 0);
export class CreateSimpleEventTypeRequest {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateSimpleEventTypeRequest.prototype, "company_id", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateSimpleEventTypeRequest.prototype, "name", void 0);
__decorate([
    IsIn(['company', 'employee', 'company_employee', 'employee_company']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateSimpleEventTypeRequest.prototype, "pattern", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsNotEmpty(),
    __metadata("design:type", Array)
], CreateSimpleEventTypeRequest.prototype, "documents", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateSimpleEventTypeRequest.prototype, "signature_group_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateSimpleEventTypeRequest.prototype, "custom_type", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateSimpleEventTypeRequest.prototype, "person_accept", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateSimpleEventTypeRequest.prototype, "person_upload", void 0);
export class EmployeesUploadRequest {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EmployeesUploadRequest.prototype, "company_id", void 0);
__decorate([
    Type(() => String),
    IsNotEmpty(),
    __metadata("design:type", File)
], EmployeesUploadRequest.prototype, "file", void 0);
export class EmployeeCompetencyEventsRequest {
}
__decorate([
    ValidateNested(),
    Type(() => Pagination),
    IsOptional(),
    __metadata("design:type", Pagination)
], EmployeeCompetencyEventsRequest.prototype, "pagination", void 0);
export class EventListExportRequest {
}
__decorate([
    IsIn(['xlsx']),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], EventListExportRequest.prototype, "format", void 0);
__decorate([
    ValidateNested(),
    Type(() => EventListRequestFilters),
    IsOptional(),
    __metadata("design:type", EventListRequestFilters)
], EventListExportRequest.prototype, "filters", void 0);
export class EventListCountsRequest {
}
__decorate([
    ValidateNested(),
    Type(() => EventListRequestFilters),
    IsOptional(),
    __metadata("design:type", EventListRequestFilters)
], EventListCountsRequest.prototype, "filters", void 0);
export class EventListToPaperRequest {
}
__decorate([
    ValidateNested(),
    Type(() => Pagination),
    IsOptional(),
    __metadata("design:type", Pagination)
], EventListToPaperRequest.prototype, "pagination", void 0);
export class EventDocumentCountRequest {
}
__decorate([
    ValidateNested(),
    Type(() => EventListRequestFilters),
    IsOptional(),
    __metadata("design:type", EventListRequestFilters)
], EventDocumentCountRequest.prototype, "filters", void 0);
export class EventPdfRequest {
}
__decorate([
    ValidateNested(),
    Type(() => EventListRequestFilters),
    IsOptional(),
    __metadata("design:type", EventListRequestFilters)
], EventPdfRequest.prototype, "filters", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], EventPdfRequest.prototype, "event_ids", void 0);
export class EventXlsxRequest {
}
__decorate([
    ValidateNested(),
    Type(() => EventListRequestFilters),
    IsOptional(),
    __metadata("design:type", EventListRequestFilters)
], EventXlsxRequest.prototype, "filters", void 0);
export class CandidateEventsFilter {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CandidateEventsFilter.prototype, "actor", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CandidateEventsFilter.prototype, "company", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CandidateEventsFilter.prototype, "employee_id", void 0);
__decorate([
    IsIn(['upload', 'sign', 'accept', 'finished', 'canceled'], { each: true }),
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CandidateEventsFilter.prototype, "status", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CandidateEventsFilter.prototype, "side", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CandidateEventsFilter.prototype, "segments", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CandidateEventsFilter.prototype, "document_type", void 0);
__decorate([
    ValidateNested(),
    Type(() => TimeRange),
    IsOptional(),
    __metadata("design:type", TimeRange)
], CandidateEventsFilter.prototype, "deadline", void 0);
export class CandidateEventListRequest {
}
__decorate([
    ValidateNested(),
    Type(() => Pagination),
    IsOptional(),
    __metadata("design:type", Pagination)
], CandidateEventListRequest.prototype, "pagination", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CandidateEventListRequest.prototype, "urgent_first", void 0);
__decorate([
    ValidateNested(),
    Type(() => CandidateEventsFilter),
    IsOptional(),
    __metadata("design:type", CandidateEventsFilter)
], CandidateEventListRequest.prototype, "filters", void 0);
export class CreateEventBatchRequest {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateEventBatchRequest.prototype, "event_type_id", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateEventBatchRequest.prototype, "all_employees", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CreateEventBatchRequest.prototype, "unit_ids", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CreateEventBatchRequest.prototype, "positions", void 0);
__decorate([
    IsUUID(undefined, { each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CreateEventBatchRequest.prototype, "employee_ids", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateEventBatchRequest.prototype, "event_batch_id", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateEventBatchRequest.prototype, "event_batch_name", void 0);
__decorate([
    Transform(({ value }) => 'hidden *****', { groups: ['sensitive'] }),
    Type(() => String),
    IsOptional(),
    __metadata("design:type", File)
], CreateEventBatchRequest.prototype, "document", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateEventBatchRequest.prototype, "document_date", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateEventBatchRequest.prototype, "document_number", void 0);
__decorate([
    IsString({ each: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CreateEventBatchRequest.prototype, "assigned_roles", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateEventBatchRequest.prototype, "parent_event_id", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", Object)
], CreateEventBatchRequest.prototype, "attributes", void 0);
export class AssignedRole {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AssignedRole.prototype, "role_id", void 0);
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AssignedRole.prototype, "group_id", void 0);
export class CreateEventRequest {
}
__decorate([
    IsUUID(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CreateEventRequest.prototype, "event_type_id", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateEventRequest.prototype, "employee_id", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => AssignedRole),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CreateEventRequest.prototype, "assigned_roles", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreateEventRequest.prototype, "parent_event_id", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", Object)
], CreateEventRequest.prototype, "attributes", void 0);
let EventsService = class EventsService {
    constructor(validator, http, unmarshaller, query) {
        this.validator = validator;
        this.http = http;
        this.unmarshaller = unmarshaller;
        this.query = query;
    }
    getEventEmployeeAbsenceList(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetEventEmployeeAbsenceListParams),
            ]);
            let requestPath = '/event/{event_id}/absences';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true, reloadIfOldVersion: true });
            const response = yield this.unmarshaller.unmarshall(result, AbsenceListResponse);
            return response;
        });
    }
    getEventEmployees(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEventEmployeesQuery),
                this.validator.validateOrReject(params, GetEventEmployeesParams),
            ]);
            let requestPath = '/event/{event_id}/employees';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, query, {
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, GetEventEmployeesResponse);
            return response;
        });
    }
    getEventStaffPositionEmployees(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEventStaffPositionEmployeesQuery),
                this.validator.validateOrReject(params, GetEventStaffPositionEmployeesParams),
            ]);
            let requestPath = '/event/{event_id}/staff_position_employees';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, query, {
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, GetEventStaffPositionEmployeesResponse);
            return response;
        });
    }
    getEventCompetencyOptions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEventCompetencyOptionsQuery),
                this.validator.validateOrReject(params, GetEventCompetencyOptionsParams),
            ]);
            let requestPath = '/event/{event_id}/competency_options';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, query, {
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, GetEventCompetencyOptionsResponse);
            return response;
        });
    }
    getEventAttributeOptions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEventAttributeOptionsQuery),
                this.validator.validateOrReject(params, GetEventAttributeOptionsParams),
            ]);
            let requestPath = '/event/{event_id}/attribute/{attribute_id}/options';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, query, {
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, EventCatalogAttributes);
            return response;
        });
    }
    getVacationScheduleEvent(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetVacationScheduleEventParams),
            ]);
            let requestPath = '/vacation/event/{event_id}';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true, reloadIfOldVersion: true });
            const response = yield this.unmarshaller.unmarshall(result, ScheduleEvent);
            return response;
        });
    }
    getScheduleConsecutiveNumberFilterOptions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetScheduleConsecutiveNumberFilterOptionsQuery),
            ]);
            let requestPath = '/vacation/schedule/available_filters/consecutive_number_options';
            const result = yield this.http.get(requestPath, query, {
                withSide: true,
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, VacationScheduleAvailableFiltersConsecutiveNumberOptionsResponse);
            return response;
        });
    }
    getScheduleEventEmployeeFilterOptions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetScheduleEventEmployeeFilterOptionsQuery),
            ]);
            let requestPath = '/vacation/schedule/available_filters/employee_options';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getAvailableScheduleEventFilters(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetAvailableScheduleEventFiltersParams),
            ]);
            let requestPath = '/vacation/schedule/{schedule_id}/available_filters';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true, reloadIfOldVersion: true });
            const response = yield this.unmarshaller.unmarshall(result, FiltersResponse);
            return response;
        });
    }
    getScheduleFavoritesEvents(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetScheduleFavoritesEventsQuery),
                this.validator.validateOrReject(params, GetScheduleFavoritesEventsParams),
            ]);
            let requestPath = '/vacation/schedule/{schedule_id}/favorites/list';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, query, {
                withSide: true,
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, ScheduleFavoriteEventsListResponse);
            return response;
        });
    }
    getScheduleEventsXlsx(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body = {}, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetScheduleEventsXlsxParams),
                this.validator.validateOrReject(body, ScheduleEventsXlsxRequest),
            ]);
            let requestPath = '/vacation/schedule/{schedule_id}/xlsx';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, ScheduleEventsXlsxResponse);
            return response;
        });
    }
    getScheduleEvents(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body = {}, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetScheduleEventsParams),
                this.validator.validateOrReject(body, ScheduleEventsListRequest),
            ]);
            let requestPath = '/vacation/schedule/{schedule_id}/list';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, ScheduleEventsListResponse);
            return response;
        });
    }
    eventAttributeCacheFile(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, EventAttributeCacheFileParams),
                this.validator.validateOrReject(body, EventAttributeCacheFileRequest),
            ]);
            let requestPath = '/event/{event_id}/attribute/{attribute_id}/cache_file';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                isJson: false,
            });
            const response = yield this.unmarshaller.unmarshall(result, EventAttributeCacheFileResponse);
            return response;
        });
    }
    getEventAttributeFile(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEventAttributeFileQuery),
                this.validator.validateOrReject(params, GetEventAttributeFileParams),
            ]);
            let requestPath = '/event/{event_id}/attribute/{attribute_id}/file';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.getFile(requestPath, {
                withAuth: true,
                withSide: true,
                isJson: true,
            }, query);
            return result;
        });
    }
    getFileHashes(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, GetEventFileHashesRequest),
            ]);
            let requestPath = '/event/batch/document/hash';
            const result = yield this.http.post(requestPath, body, {});
            const response = yield this.unmarshaller.unmarshall(result, GetEventFileHashesResponse);
            return response;
        });
    }
    markDocumentAsRead(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, MarkDocumentAsReadParams),
            ]);
            let requestPath = '/event/{event_id}/document/{document_id}/mark_read';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, {}, { withSide: true });
            return result;
        });
    }
    getEventDocumentFileHash(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetEventDocumentFileHashParams),
            ]);
            let requestPath = '/event/{event_id}/document/{document_id}/file/hash';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, {});
            const response = yield this.unmarshaller.unmarshall(result, GetEventDocumentFileHashResponse);
            return response;
        });
    }
    eventFlowPdf(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, EventFlowPdfParams),
            ]);
            let requestPath = '/event/{event_id}/flow_pdf';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.getFile(requestPath, {
                withAuth: true,
                withSide: false,
                isJson: true,
            });
            return result;
        });
    }
    createEventBatchDocumentZip(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body, }) {
            yield Promise.all([
                this.validator.validateOrReject(body, CreateEventBatchDocumentZipRequest),
            ]);
            let requestPath = '/event/batch/document/zip';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, CreateEventBatchDocumentZipResponse);
            return response;
        });
    }
    requestEventDocumentDocxFile(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, RequestEventDocumentDocxFileParams),
            ]);
            let requestPath = '/event/{event_id}/document/docx';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, RequestEventDocumentDocxResponse);
            return response;
        });
    }
    getEventDocumentZip(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetEventDocumentZipParams),
            ]);
            let requestPath = '/event/{event_id}/document/{document_id}/zip';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.getFile(requestPath, {
                withAuth: true,
                withSide: true,
                isJson: true,
            });
            return result;
        });
    }
    getEventDocumentFileWithStamp(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetEventDocumentFileWithStampParams),
            ]);
            let requestPath = '/event/{event_id}/document/{document_id}/file_with_stamp';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.getFile(requestPath, {
                withAuth: true,
                withSide: true,
                isJson: true,
            });
            return result;
        });
    }
    getEventDocumentFile(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetEventDocumentFileParams),
            ]);
            let requestPath = '/event/{event_id}/document/{document_id}/file';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.getFile(requestPath, {
                withAuth: true,
                withSide: true,
                isJson: true,
            });
            return result;
        });
    }
    doCompetencyProfile(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DoCompetencyProfileParams),
                this.validator.validateOrReject(body, CompetencyProfileRequest),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/competency_profile';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                isJson: false,
            });
            return result;
        });
    }
    doCompetencyEval(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DoCompetencyEvalParams),
                this.validator.validateOrReject(body, CompetencyEvalRequest),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/competency_eval';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                isJson: false,
            });
            return result;
        });
    }
    doBatchReturn(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, BatchReturnRequest),
            ]);
            let requestPath = '/event/batch/return';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, BatchEventOperationResponse);
            return response;
        });
    }
    doBatchAccept(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, BatchAcceptRequest),
            ]);
            let requestPath = '/event/batch/accept';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, BatchEventAcceptResponse);
            return response;
        });
    }
    doBatchPepSign(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, PepBatchSignRequest),
            ]);
            let requestPath = '/event/batch/pep_sign';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, BatchEventOperationResponse);
            return response;
        });
    }
    doPepSign(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DoPepSignParams),
                this.validator.validateOrReject(body, PepSignRequest),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/pep_sign';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                isJson: false,
            });
            return result;
        });
    }
    doBatchUkepSign(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, UkepBatchSignRequest),
            ]);
            let requestPath = '/event/batch/ukep_sign';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, BatchEventOperationResponse);
            return response;
        });
    }
    doUkepSign(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DoUkepSignParams),
                this.validator.validateOrReject(body, UkepSignRequest),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/ukep_sign';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                isJson: false,
            });
            return result;
        });
    }
    requestUnepSignBatchCode(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, RequestUnepSignBatchCodeParams),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/unep_sign_batch/code';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, {}, { withSide: true });
            return result;
        });
    }
    doUnepSignBatch(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DoUnepSignBatchParams),
                this.validator.validateOrReject(body, UnepSignRequest),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/unep_sign_batch';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                isJson: false,
            });
            return result;
        });
    }
    requestUnepSignCode(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, RequestUnepSignCodeParams),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/unep_sign/code';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, {}, { withSide: true });
            return result;
        });
    }
    doUnepSign(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DoUnepSignParams),
                this.validator.validateOrReject(body, UnepSignRequest),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/unep_sign';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                isJson: false,
            });
            return result;
        });
    }
    documentGenerateFromTemplate(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DocumentGenerateFromTemplateParams),
                this.validator.validateOrReject(body, GenerateDocumentRequest),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/generate_document_from_template';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                isJson: false,
            });
            return result;
        });
    }
    documentGeneratePreviewFromTemplate(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DocumentGeneratePreviewFromTemplateParams),
                this.validator.validateOrReject(body, GenerateDocumentRequest),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/generate_document_preview';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.generateFile(requestPath, body, {
                method: 'put',
                withSide: true,
                isJson: false,
            });
            return result;
        });
    }
    doDeclineSign(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DoDeclineSignParams),
                this.validator.validateOrReject(body, DeclineSignRequest),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/decline_sign';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                isJson: false,
            });
            return result;
        });
    }
    doDecline(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DoDeclineParams),
                this.validator.validateOrReject(body, DeclineRequest),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/decline';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                isJson: false,
            });
            return result;
        });
    }
    doRetry(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([this.validator.validateOrReject(params, DoRetryParams)]);
            let requestPath = '/event/{event_id}/{node_id}/{action_type}/retry';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, {}, { withSide: true });
            return result;
        });
    }
    eventAttributesReset(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, EventAttributesResetParams),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/{action_type}/reset';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, {}, {});
            const response = yield this.unmarshaller.unmarshall(result, Action);
            return response;
        });
    }
    candidateEsiaExternalProcessingCallback(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, CandidateEsiaExternalProcessingCallbackQuery),
            ]);
            let requestPath = '/event/external-processing/esia/callback';
            const result = yield this.http.get(requestPath, query, {});
            return result;
        });
    }
    eventNodeActionExternalProcessing(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, EventNodeActionExternalProcessingParams),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/{action_type}/external-processing';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, {}, {});
            return result;
        });
    }
    doAccept(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DoAcceptParams),
                this.validator.validateOrReject(body, AcceptRequest),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/accept';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                isJson: false,
            });
            return result;
        });
    }
    doReturn(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DoReturnParams),
                this.validator.validateOrReject(body, ReturnRequest),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/return';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, { withSide: true });
            return result;
        });
    }
    doUploadBatch(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DoUploadBatchParams),
                this.validator.validateOrReject(body, UploadBatchRequest),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/upload_batch';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                isJson: false,
            });
            return result;
        });
    }
    doUpload(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, DoUploadParams),
                this.validator.validateOrReject(body, UploadRequest),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/upload';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                isJson: false,
            });
            return result;
        });
    }
    eventNodeValidators(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, EventNodeValidatorsParams),
            ]);
            let requestPath = '/event/{event_id}/{node_id}/validators';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true, reloadIfOldVersion: true });
            const response = yield this.unmarshaller.unmarshall(result, ValidatorList);
            return response;
        });
    }
    eventToPaper(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([this.validator.validateOrReject(body, ToPaperRequest)]);
            let requestPath = '/event/batch/to_paper';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            return result;
        });
    }
    restoreEvent(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, RestoreEventParams),
            ]);
            let requestPath = '/event/{event_id}/restore';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, {}, { withSide: true });
            return result;
        });
    }
    cancelEvent(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, CancelEventParams),
                this.validator.validateOrReject(body, CancelEventRequest),
            ]);
            let requestPath = '/event/{event_id}/cancel';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, { withSide: true });
            return result;
        });
    }
    doBatchCancel() {
        return __awaiter(this, arguments, void 0, function* ({ body = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(body, BatchCancelRequest),
            ]);
            let requestPath = '/event/batch/cancel';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, BatchEventCancelResponse);
            return response;
        });
    }
    ukepListEvents() {
        return __awaiter(this, arguments, void 0, function* ({ body = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(body, EventsUkepListRequest),
            ]);
            let requestPath = '/event/to_sign_ukep/ids';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EventsUkepListResponse);
            return response;
        });
    }
    getBatchEventOperationsInfo() {
        return __awaiter(this, arguments, void 0, function* ({ body = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(body, EventListRequest),
            ]);
            let requestPath = '/event/batch_operations/info';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, BatchEventOperationsInfoResponse);
            return response;
        });
    }
    operationEvents(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, EventOperationsRequest),
            ]);
            let requestPath = '/event/operations';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EventOperationsResponse);
            return response;
        });
    }
    getEvent(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetEventParams),
            ]);
            let requestPath = '/event/{event_id}';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, Event);
            return response;
        });
    }
    getEventFlow(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetEventFlowParams),
            ]);
            let requestPath = '/event/{event_id}/flow';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EventFlow);
            return response;
        });
    }
    getBookingSmartwayRedirect(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, GetBookingSmartwayRedirectParams),
            ]);
            let requestPath = '/event/{event_id}/booking/smartway/trip';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withAuth: false });
            return result;
        });
    }
    getBookingRedirect(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetBookingRedirectQuery),
                this.validator.validateOrReject(params, GetBookingRedirectParams),
            ]);
            let requestPath = '/event/{event_id}/booking/corteos/trip';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, query, { withAuth: false });
            return result;
        });
    }
    createSimpleEventType(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body, }) {
            yield Promise.all([
                this.validator.validateOrReject(body, CreateSimpleEventTypeRequest),
            ]);
            let requestPath = '/event_type/simple';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, CreateSimpleEventTypeResponse);
            return response;
        });
    }
    getCreateSimpleEventTypeOptions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetCreateSimpleEventTypeOptionsQuery),
            ]);
            let requestPath = '/event_type/simple/create_options';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, CreateSimpleEventTypeOptionsResponse);
            return response;
        });
    }
    getCreateSimpleEventTypeCompanies() {
        return __awaiter(this, void 0, void 0, function* () {
            let requestPath = '/event_type/simple/create_companies';
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, CreateSimpleEventTypeCompaniesResponse);
            return response;
        });
    }
    getEventStatusFilterOptions() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEventStatusFilterOptionsQuery),
            ]);
            let requestPath = '/event/available_filters/status_options';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getEventSideFilterOptions() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEventSideFilterOptionsQuery),
            ]);
            let requestPath = '/event/available_filters/side_options';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getEventTypeGroupFilterOptions() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEventTypeGroupFilterOptionsQuery),
            ]);
            let requestPath = '/event/available_filters/event_type_group_options';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getDocumentTypeFilterOptions() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetDocumentTypeFilterOptionsQuery),
            ]);
            let requestPath = '/event/available_filters/document_type_options';
            const result = yield this.http.get(requestPath, query, {});
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getParentEventFilterOptions() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetParentEventFilterOptionsQuery),
            ]);
            let requestPath = '/event/available_filters/parent_event_options';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getEventBatchFilterOptions() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEventBatchFilterOptionsQuery),
            ]);
            let requestPath = '/event/available_filters/event_batch_options';
            const result = yield this.http.get(requestPath, query, {});
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getEmployeePositionFilterOptions() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEmployeePositionFilterOptionsQuery),
            ]);
            let requestPath = '/event/available_filters/employee_position_options';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getBusinessTripDestinationFilterOptions() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetBusinessTripDestinationFilterOptionsQuery),
            ]);
            let requestPath = '/event/available_filters/business_trip_destination_options';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EventAvailableFiltersBusinessTripDestinationOptionsResponse);
            return response;
        });
    }
    getConsecutiveNumberFilterOptions() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetConsecutiveNumberFilterOptionsQuery),
            ]);
            let requestPath = '/event/available_filters/consecutive_number_options';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EventAvailableFiltersConsecutiveNumberOptionsResponse);
            return response;
        });
    }
    getEmployeeFilterOptions() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEmployeeFilterOptionsQuery),
            ]);
            let requestPath = '/event/available_filters/employee_options';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getAttrOptions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetAttrOptionsQuery),
                this.validator.validateOrReject(params, GetAttrOptionsParams),
            ]);
            let requestPath = '/event/available_filters/attr_options/{attr_code}';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, query, { withSide: true });
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getAvailableEventFiltersAbsence() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetAvailableEventFiltersAbsenceQuery),
            ]);
            let requestPath = '/event/absence_available_filters';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, AvailableFilters);
            return response;
        });
    }
    getAvailableEventFilters() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetAvailableEventFiltersQuery),
            ]);
            let requestPath = '/event/available_filters';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, FiltersResponse);
            return response;
        });
    }
    getCreateEventOptionsEventTypes(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetCreateEventOptionsEventTypesQuery),
            ]);
            let requestPath = '/event/create_options/event_types';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, CreateEventOptionsEventTypes);
            return response;
        });
    }
    getEventTypeCreateOptions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEventTypeCreateOptionsQuery),
            ]);
            let requestPath = '/event/create_options/event_type';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, CreateEventTypeOptions);
            return response;
        });
    }
    eventEmployeesUpload(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, EmployeesUploadRequest),
            ]);
            let requestPath = '/event/employees/upload';
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                isJson: false,
            });
            const response = yield this.unmarshaller.unmarshall(result, EmployeesUploadResponse);
            return response;
        });
    }
    employeeCompetencyEvents(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params, body = {}, }) {
            yield Promise.all([
                this.validator.validateOrReject(params, EmployeeCompetencyEventsParams),
                this.validator.validateOrReject(body, EmployeeCompetencyEventsRequest),
            ]);
            let requestPath = '/employee/{employee_id}/competency/events';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EmployeeCompetencyEventsResponse);
            return response;
        });
    }
    employeeCompetency(_a) {
        return __awaiter(this, arguments, void 0, function* ({ params }) {
            yield Promise.all([
                this.validator.validateOrReject(params, EmployeeCompetencyParams),
            ]);
            let requestPath = '/employee/{employee_id}/competency';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, {}, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EmployeeCompetencyResponse);
            return response;
        });
    }
    getCreateEventOptionsEmployeeEventTypes(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, params, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetCreateEventOptionsEmployeeEventTypesQuery),
                this.validator.validateOrReject(params, GetCreateEventOptionsEmployeeEventTypesParams),
            ]);
            let requestPath = '/event/create_options/employees/{employee_id}/event_types';
            const paramsKeys = Object.keys(params);
            if (paramsKeys.length) {
                paramsKeys.forEach((param) => {
                    requestPath = requestPath.replace(`{${param}}`, encodeURIComponent(String(params[param])));
                });
            }
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EmployeeCreatableEventTypes);
            return response;
        });
    }
    getCreateEventOptionsEmployees(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetCreateEventOptionsEmployeesQuery),
            ]);
            let requestPath = '/event/create_options/employees';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EmployeesList);
            return response;
        });
    }
    eventCreateOptionsEventTypeParticipantOptions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, EventCreateOptionsEventTypeParticipantOptionsQuery),
            ]);
            let requestPath = '/event/create_options/event_type/participant_options';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, CreateEventTypeParticipantOptions);
            return response;
        });
    }
    getCreateEventOptionsCompanies() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetCreateEventOptionsCompaniesQuery),
            ]);
            let requestPath = '/event/create_options/companies';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, CreateEventCompanyOptionsList);
            return response;
        });
    }
    getCreateEventOptionsCommon(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetCreateEventOptionsCommonQuery),
            ]);
            let requestPath = '/event/create_options/common';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, CreateEventCommonOptionsResponse);
            return response;
        });
    }
    eventListExport(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, EventListExportRequest),
            ]);
            let requestPath = '/event/list/export';
            const result = yield this.http.generateFile(requestPath, body, {
                withSide: true,
            });
            return result;
        });
    }
    getEventCounts() {
        return __awaiter(this, arguments, void 0, function* ({ body = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(body, EventListCountsRequest),
            ]);
            let requestPath = '/event/list/counts';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EventListCountsResponse);
            return response;
        });
    }
    getEventsToPaper() {
        return __awaiter(this, arguments, void 0, function* ({ body = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(body, EventListToPaperRequest),
            ]);
            let requestPath = '/event/list/to_paper';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EventListToPaperResponse);
            return response;
        });
    }
    getDocumentCountByFilter() {
        return __awaiter(this, arguments, void 0, function* ({ body = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(body, EventDocumentCountRequest),
            ]);
            let requestPath = '/event/document_count';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EventDocumentCountResponse);
            return response;
        });
    }
    getEventsPdf() {
        return __awaiter(this, arguments, void 0, function* ({ body = {}, } = {}) {
            yield Promise.all([this.validator.validateOrReject(body, EventPdfRequest)]);
            let requestPath = '/event/pdf';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EventPdfResponse);
            return response;
        });
    }
    getEventsXlsx(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, body = {}, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEventsXlsxQuery),
                this.validator.validateOrReject(body, EventXlsxRequest),
            ]);
            let requestPath = '/event/xlsx';
            requestPath = `${requestPath}${query && Object.keys(query).length
                ? `?${this.query.stringify(query)}`
                : ''}`;
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EventXlsxResponse);
            return response;
        });
    }
    getEvents() {
        return __awaiter(this, arguments, void 0, function* ({ body = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(body, EventListRequest),
            ]);
            let requestPath = '/event/list';
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, EventListResponse);
            return response;
        });
    }
    candidateEventListAvailableFilters() {
        return __awaiter(this, void 0, void 0, function* () {
            let requestPath = '/candidate/event/list/available_filters';
            const result = yield this.http.get(requestPath, {}, { reloadIfOldVersion: true });
            const response = yield this.unmarshaller.unmarshall(result, FiltersResponse);
            return response;
        });
    }
    candidateEventList() {
        return __awaiter(this, arguments, void 0, function* ({ body = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(body, CandidateEventListRequest),
            ]);
            let requestPath = '/candidate/event/list';
            const result = yield this.http.post(requestPath, body, {
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, CandidateEventListResponse);
            return response;
        });
    }
    getEventBatchEmployeeCount(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEventBatchEmployeeCountQuery),
            ]);
            let requestPath = '/event/batch/employee_count';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EventBatchEmployeeCountResponse);
            return response;
        });
    }
    getEventBatchPositions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEventBatchPositionsQuery),
            ]);
            let requestPath = '/event/batch/positions';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            class Response {
            }
            __decorate([
                ValidateNested(),
                Type(() => FilterSelectOption),
                __metadata("design:type", Array)
            ], Response.prototype, "response", void 0);
            const { response } = yield this.unmarshaller.unmarshall({ response: result }, Response);
            return response;
        });
    }
    getEventBatchEmployees(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query, }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEventBatchEmployeesQuery),
            ]);
            let requestPath = '/event/batch/employees';
            const result = yield this.http.get(requestPath, query, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, EventBatchEmployeesResponse);
            return response;
        });
    }
    createEventBatch(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, CreateEventBatchRequest),
            ]);
            let requestPath = '/event/batch';
            const result = yield this.http.post(requestPath, body, {
                withSide: true,
                isJson: false,
            });
            const response = yield this.unmarshaller.unmarshall(result, CreateEventBatchResponse);
            return response;
        });
    }
    getEventBatchList(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query }) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetEventBatchListQuery),
            ]);
            let requestPath = '/event/batch';
            const result = yield this.http.get(requestPath, query, {
                withSide: true,
                reloadIfOldVersion: true,
            });
            const response = yield this.unmarshaller.unmarshall(result, EventBatchListResponse);
            return response;
        });
    }
    createEvent(_a) {
        return __awaiter(this, arguments, void 0, function* ({ body }) {
            yield Promise.all([
                this.validator.validateOrReject(body, CreateEventRequest),
            ]);
            let requestPath = '/event';
            const result = yield this.http.post(requestPath, body, { withSide: true });
            const response = yield this.unmarshaller.unmarshall(result, CreateEventResponse);
            return response;
        });
    }
    getCancelReasons() {
        return __awaiter(this, arguments, void 0, function* ({ query = {}, } = {}) {
            yield Promise.all([
                this.validator.validateOrReject(query, GetCancelReasonsQuery),
            ]);
            let requestPath = '/event/cancel_reasons';
            const result = yield this.http.get(requestPath, query, {});
            const response = yield this.unmarshaller.unmarshall(result, CancelReasonListResponse);
            return response;
        });
    }
};
EventsService = __decorate([
    injectable(),
    __metadata("design:paramtypes", [ValidationService,
        HttpService,
        UnmarshallerService,
        QueryService])
], EventsService);
export { EventsService };
